var _rect, _rect2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepageHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1316,
    viewBox: "0 0 1440 1316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -54,
    width: 1550,
    height: 1091,
    fill: "url(#paint0_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3004_95",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -54,
    y: 0,
    width: 1550,
    height: 1043
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -54,
    width: 1550,
    height: 1043,
    fill: "url(#paint1_linear_3004_95)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3004_95)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.346 526.024L153.077 490.446L181.097 503.935L177.01 539.252C177.01 539.252 183.763 544.699 182.772 549.945C180.36 562.714 146.03 553.396 146.03 553.396C146.03 553.396 115.612 542.589 122.11 532.275C125.498 526.896 136.346 526.024 136.346 526.024Z",
    fill: "#5F4077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.878 259.265L191.912 240.091C190.879 238.989 190.899 237.269 191.958 236.192L210.756 217.055L233.285 198.547C234.357 197.667 235.91 197.698 236.946 198.621L258.576 217.89L277.334 237.646C278.401 238.769 278.36 240.543 277.243 241.616L257.837 260.247L235.472 277.052C234.445 277.824 233.025 277.803 232.022 277.001L210.174 259.539C210.069 259.455 209.97 259.363 209.878 259.265Z",
    fill: "url(#paint2_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.978 395.992L156.905 348.1C157.357 347.648 158.059 347.558 158.611 347.881L226.847 387.824C228.073 388.542 228.247 390.229 227.17 391.155C219.734 397.544 194.321 418.046 172.77 419.577C149.307 421.243 117.182 403.253 109.284 398.584C108.349 398.031 108.209 396.76 108.978 395.992Z",
    fill: "url(#paint3_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.53 400.535L309.304 351.001C308.867 350.532 308.17 350.418 307.606 350.722L238.017 388.259C236.767 388.934 236.534 390.614 237.579 391.577C244.788 398.221 269.469 419.598 290.953 421.88C314.344 424.364 347.077 407.506 355.134 403.115C356.088 402.595 356.271 401.33 355.53 400.535Z",
    fill: "url(#paint4_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.438 370.924L114.797 294.833C114.986 293.668 116.438 293.239 117.23 294.114L155.693 336.607C156.557 337.562 156.373 339.061 155.303 339.778L105.699 373.017C104.164 374.045 102.142 372.747 102.438 370.924Z",
    fill: "url(#paint5_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.201 375.458L352.506 298.982C352.357 297.811 350.921 297.331 350.099 298.178L310.177 339.303C309.279 340.227 309.411 341.732 310.456 342.486L358.869 377.436C360.367 378.517 362.433 377.29 362.201 375.458Z",
    fill: "url(#paint6_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.497 274.754C123.768 259.251 148.699 224.626 154.017 217.414C154.539 216.706 155.554 216.676 156.152 217.321C161.379 222.954 183.337 246.386 197.893 258.238C210.844 268.783 211.348 268.343 212.712 275.348C216.401 294.286 175.292 317.698 159.962 315.594C137.929 312.57 123.262 288.231 123.497 274.754Z",
    fill: "url(#paint7_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.777 278.581C343.047 263.078 319.34 227.605 314.277 220.211C313.78 219.485 312.766 219.42 312.146 220.044C306.727 225.491 283.963 248.142 269.003 259.479C255.692 269.566 255.204 269.108 253.596 276.062C249.248 294.859 289.515 319.692 304.909 318.124C327.034 315.87 342.542 292.059 342.777 278.581Z",
    fill: "url(#paint8_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.078 181.511C189.586 180.333 194.684 172.238 199.178 170.39C203.671 168.542 206.493 177.258 210.365 182.622C214.237 187.986 215.94 189.813 215.841 195.477C215.766 199.809 214.431 202.017 212.44 205.769C210.448 209.521 206.762 213.537 202.579 216.912C197.388 221.101 192.79 223.889 186.117 222.884C182.409 222.326 181.366 221.824 178.507 218.659C173.936 213.597 173.657 209.371 174.572 202.701C175.772 193.961 188.078 181.511 188.078 181.511Z",
    fill: "url(#paint9_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.889 183.2C281.423 181.97 276.61 173.701 272.184 171.698C267.758 169.695 264.633 178.306 260.576 183.532C256.52 188.758 254.754 190.524 254.655 196.188C254.579 200.52 255.836 202.774 257.695 206.593C259.555 210.412 263.098 214.554 267.161 218.073C272.203 222.44 276.701 225.387 283.405 224.616C287.13 224.187 288.189 223.723 291.157 220.659C295.902 215.76 296.329 211.546 295.647 204.848C294.753 196.071 282.889 183.2 282.889 183.2Z",
    fill: "url(#paint10_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94 167.435L235.514 145.441C236.078 144.838 237.037 144.847 237.589 145.461L258.018 168.152C259.059 169.308 258.965 171.09 257.807 172.13L236.721 191.082C236.165 191.582 235.316 191.56 234.787 191.033L215.01 171.355C213.931 170.282 213.9 168.546 214.94 167.435Z",
    fill: "url(#paint11_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.113 329.28L233.286 291.758C233.725 291.517 234.26 291.527 234.69 291.785L300.577 331.418C301.957 332.248 301.937 334.256 300.541 335.058L233.274 373.741C232.828 373.997 232.278 373.99 231.838 373.722L165.03 332.933C163.646 332.087 163.692 330.062 165.113 329.28Z",
    fill: "url(#paint12_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.783 411.682C230.783 411.682 257.268 423.134 289.986 429.888C312.109 434.455 335.209 424.362 344.678 416.966C347.317 414.905 348.406 416.391 348.53 419.737C349.091 434.92 345.482 465.038 315.454 488.03C273.95 519.809 233.221 519.807 228.897 519.731L230.783 411.682Z",
    fill: "url(#paint13_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.782 411.542C230.782 411.542 203.914 422.063 170.98 427.671C148.711 431.463 125.978 420.57 116.772 412.848C114.207 410.697 113.067 412.143 112.826 415.483C111.735 430.637 114.291 460.862 143.498 484.888C183.868 518.097 224.572 519.516 228.896 519.592L230.782 411.542Z",
    fill: "url(#paint14_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.01 527.339L302.837 493.015L275.827 508.425L282.367 543.372C282.367 543.372 276.011 549.276 277.365 554.441C280.662 567.01 314.259 555.32 314.259 555.32C314.259 555.32 343.848 542.418 336.647 532.582C332.892 527.452 322.01 527.339 322.01 527.339Z",
    fill: "#5F4077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.346 526.024L153.078 490.446L181.097 503.935L177.011 539.252C177.011 539.252 183.763 544.699 182.772 549.945C180.36 562.714 146.03 553.396 146.03 553.396C146.03 553.396 115.613 542.589 122.11 532.275C125.499 526.896 136.346 526.024 136.346 526.024Z",
    fill: "#5F4077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.878 259.265L191.912 240.091C190.879 238.989 190.899 237.269 191.958 236.192L210.756 217.055L233.285 198.547C234.357 197.667 235.91 197.698 236.946 198.621L258.576 217.89L277.334 237.646C278.401 238.769 278.36 240.543 277.243 241.616L257.837 260.247L235.472 277.052C234.445 277.824 233.025 277.803 232.022 277.001L210.174 259.539C210.069 259.455 209.97 259.363 209.878 259.265Z",
    fill: "url(#paint15_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.978 395.992L156.905 348.1C157.357 347.648 158.059 347.558 158.611 347.881L226.847 387.824C228.073 388.542 228.247 390.229 227.17 391.155C219.734 397.544 194.321 418.046 172.77 419.577C149.307 421.243 117.182 403.253 109.284 398.584C108.349 398.031 108.209 396.76 108.978 395.992Z",
    fill: "url(#paint16_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.53 400.535L309.304 351.001C308.867 350.532 308.17 350.418 307.606 350.722L238.017 388.259C236.767 388.934 236.534 390.614 237.579 391.577C244.788 398.221 269.469 419.598 290.953 421.88C314.344 424.364 347.077 407.506 355.134 403.115C356.088 402.595 356.271 401.33 355.53 400.535Z",
    fill: "url(#paint17_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.438 370.924L114.797 294.833C114.986 293.668 116.438 293.239 117.23 294.114L155.693 336.607C156.557 337.562 156.373 339.061 155.303 339.778L105.699 373.017C104.164 374.045 102.142 372.747 102.438 370.924Z",
    fill: "url(#paint18_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.201 375.458L352.506 298.982C352.357 297.811 350.921 297.331 350.099 298.178L310.177 339.303C309.279 340.227 309.411 341.732 310.456 342.486L358.869 377.436C360.367 378.517 362.433 377.29 362.201 375.458Z",
    fill: "url(#paint19_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.497 274.754C123.768 259.251 148.699 224.626 154.017 217.414C154.539 216.706 155.554 216.676 156.152 217.321C161.379 222.954 183.337 246.386 197.893 258.238C210.844 268.783 211.348 268.343 212.712 275.348C216.401 294.286 175.292 317.698 159.962 315.594C137.929 312.57 123.262 288.231 123.497 274.754Z",
    fill: "url(#paint20_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.777 278.581C343.047 263.078 319.34 227.605 314.277 220.211C313.78 219.485 312.766 219.42 312.146 220.044C306.727 225.491 283.963 248.142 269.003 259.479C255.692 269.566 255.204 269.108 253.596 276.062C249.248 294.859 289.515 319.692 304.909 318.124C327.034 315.87 342.542 292.059 342.777 278.581Z",
    fill: "url(#paint21_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.078 181.511C189.586 180.333 194.684 172.238 199.178 170.39C203.671 168.542 206.493 177.258 210.365 182.622C214.237 187.986 215.94 189.813 215.841 195.477C215.766 199.809 214.431 202.017 212.44 205.769C210.448 209.521 206.762 213.537 202.579 216.912C197.388 221.101 192.79 223.889 186.117 222.884C182.409 222.326 181.366 221.824 178.507 218.659C173.936 213.597 173.657 209.371 174.572 202.701C175.772 193.961 188.078 181.511 188.078 181.511Z",
    fill: "url(#paint22_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.889 183.2C281.423 181.97 276.61 173.701 272.184 171.698C267.758 169.695 264.633 178.306 260.576 183.532C256.52 188.758 254.754 190.524 254.655 196.188C254.579 200.52 255.836 202.774 257.695 206.593C259.555 210.412 263.098 214.554 267.161 218.073C272.203 222.44 276.701 225.387 283.405 224.616C287.13 224.187 288.189 223.723 291.157 220.659C295.902 215.76 296.329 211.546 295.647 204.848C294.753 196.071 282.889 183.2 282.889 183.2Z",
    fill: "url(#paint23_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94 167.435L235.514 145.441C236.078 144.838 237.037 144.847 237.589 145.461L258.018 168.152C259.059 169.308 258.965 171.09 257.807 172.13L236.721 191.082C236.165 191.582 235.316 191.56 234.787 191.033L215.01 171.355C213.931 170.282 213.9 168.546 214.94 167.435Z",
    fill: "url(#paint24_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.113 329.28L233.286 291.758C233.725 291.517 234.26 291.527 234.69 291.785L300.577 331.418C301.957 332.248 301.937 334.256 300.541 335.058L233.274 373.741C232.828 373.997 232.278 373.99 231.838 373.722L165.03 332.933C163.646 332.087 163.692 330.062 165.113 329.28Z",
    fill: "url(#paint25_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.783 411.682C230.783 411.682 257.268 423.134 289.986 429.888C312.109 434.455 335.209 424.362 344.678 416.966C347.317 414.905 348.406 416.391 348.53 419.737C349.091 434.92 345.482 465.038 315.454 488.03C273.95 519.809 233.221 519.807 228.897 519.731L230.783 411.682Z",
    fill: "url(#paint26_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.782 411.542C230.782 411.542 203.914 422.063 170.98 427.671C148.711 431.463 125.978 420.57 116.772 412.848C114.207 410.697 113.067 412.143 112.826 415.483C111.735 430.637 114.291 460.862 143.498 484.888C183.868 518.097 224.572 519.516 228.896 519.592L230.782 411.542Z",
    fill: "url(#paint27_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9626,
    cy: 16.8611,
    rx: 16.9626,
    ry: 16.8611,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 428.983 307.004)",
    fill: "#5F4077"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9626,
    cy: 16.8611,
    rx: 16.9626,
    ry: 16.8611,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 91.821 433.452)",
    fill: "#5F4077"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7009,
    cy: 10.7009,
    r: 10.7009,
    transform: "matrix(-1 2.22734e-09 2.22734e-09 1 312.293 447.95)",
    fill: "#E3C4FB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7009,
    cy: 10.7009,
    r: 10.7009,
    transform: "matrix(-1 2.22734e-09 2.22734e-09 1 172.637 447.95)",
    fill: "#E3C4FB"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9626,
    cy: 16.8611,
    rx: 16.9626,
    ry: 16.8611,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 493.844 384.896)",
    fill: "#5F4077",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9626,
    cy: 16.8611,
    rx: 16.9626,
    ry: 16.8611,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 475.017 350.743)",
    fill: "#5F4077",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9626,
    cy: 16.8611,
    rx: 16.9626,
    ry: 16.8611,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 458.499 328.945)",
    fill: "#5F4077",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9626,
    cy: 16.8611,
    rx: 16.9626,
    ry: 16.8611,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 443.472 315.931)",
    fill: "#5F4077",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3957 231.671C36.014 256.471 34.3605 255.842 20.9824 272.59C25.2128 260.309 22.4078 249.552 21.8934 234.77L15.3109 244.165C10.5248 230.644 5.32498 225.494 -6.29721 218.576L-11.7052 228.319C-23.107 214.311 -28.6122 206.876 -31.5569 189.927L-34.5165 199.011C-34.5165 199.011 -69.9892 160.559 -67.1857 131.458C-65.4186 113.115 -61.6009 99.8062 -47.9006 88.4615C-50.2967 78.2326 -81.5577 84.0912 -71.7582 75.1373C-61.9586 66.1835 -45.0398 86.2284 -45.0398 86.2284C-28.8929 74.3502 -13.2772 74.9368 6.53095 79.9359C39.7694 88.3245 58.8794 142.605 63.7496 152.547C74.9294 175.368 56.8666 234.531 56.8666 234.531C56.8666 234.531 52.7773 206.87 44.3957 231.671Z",
    fill: "url(#paint28_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.769 113.21C848.932 117.425 848.713 115.669 827.649 111.697C840.481 109.68 848.67 102.163 861.488 94.7825L850.104 93.3688C859.806 82.806 861.92 75.799 862.587 62.2902L851.445 62.0773C858.478 45.4416 862.468 37.0941 876.062 26.5516L866.65 28.1932C866.65 28.1932 884.001 -21.1607 911.023 -32.3184C928.057 -39.3515 941.603 -42.2142 958.044 -35.4259C965.958 -42.3352 946.136 -67.2079 958.638 -62.7456C971.139 -58.2832 961.358 -33.9447 961.358 -33.9447C979.417 -25.2449 986.215 -11.1744 991.079 8.66731C999.241 41.9621 960.24 84.2767 953.739 93.237C938.815 113.806 878.085 125.567 878.085 125.567C878.085 125.567 900.606 108.995 874.769 113.21Z",
    fill: "url(#paint29_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.203 298.797C477.333 300.872 459.839 314.642 470.374 325.447C481.771 337.135 495.168 313.77 500.581 316.283C503.534 317.654 503.757 330.422 513.963 331.773C525.27 333.269 520.321 311.358 531.426 309.798C538.168 308.85 536.198 335.649 549.345 341.987C566.536 350.274 552.86 280.375 570.796 284.141C583.084 286.72 581.619 314.513 598.719 319.199C618.597 324.646 584.777 236.838 605.953 245.91C615.397 249.956 618.288 266.102 625.685 263.955C634.052 261.527 635.256 247.364 632.465 236.253C630.696 229.212 621.644 212.53 623.57 205.983C628.316 189.854 625.528 173.173 612.785 161.577C612.755 161.55 612.725 161.522 612.695 161.495C611.77 159.842 633.856 141.148 626.607 135.628C621.903 132.045 611.905 159.85 607.57 157.551C592.323 147.98 571.872 154.089 562.942 156.918C550.398 160.892 526.994 149.628 525.293 162.503C524.485 168.628 534.059 170.296 532.718 176.301C530.347 186.916 484.692 177.122 483.8 201.798C482.993 224.132 502.656 218.478 502.509 221.874C502.061 232.258 465.56 224.294 465.507 240.074C465.435 261.541 484.771 253.367 484.501 265.302C484.286 274.788 452.373 267.301 455.531 288.376C457.132 299.066 471.073 296.723 474.203 298.797Z",
    fill: "url(#paint30_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1429.39 637.852C1426.34 635.669 1444.3 622.521 1434.16 611.353C1423.18 599.272 1408.97 622.153 1403.64 619.451C1400.74 617.977 1400.97 605.208 1390.81 603.5C1379.57 601.608 1383.74 623.679 1372.59 624.849C1365.82 625.559 1368.73 598.846 1355.81 592.051C1338.92 583.165 1350.14 653.501 1332.34 649.108C1320.15 646.098 1322.59 618.374 1305.67 613.09C1286 606.948 1316.71 695.89 1295.87 686.08C1286.57 681.705 1284.25 665.467 1276.78 667.353C1268.33 669.486 1266.63 683.597 1269.03 694.8C1270.55 701.898 1279.01 718.888 1276.86 725.363C1271.55 741.316 1273.75 758.085 1286.08 770.121C1286.11 770.15 1286.13 770.178 1286.16 770.206C1287.03 771.89 1264.3 789.797 1271.35 795.569C1275.93 799.314 1286.9 771.877 1291.15 774.328C1306.05 784.429 1326.7 779.041 1335.73 776.528C1348.4 772.997 1371.4 785.076 1373.55 772.268C1374.57 766.175 1365.06 764.172 1366.61 758.217C1369.35 747.693 1414.64 759.084 1416.39 734.454C1417.99 712.163 1398.14 717.122 1398.4 713.734C1399.21 703.372 1435.41 712.613 1436.02 696.845C1436.85 675.393 1417.24 682.883 1417.92 670.965C1418.47 661.492 1450.1 670.096 1447.69 648.923C1446.46 638.183 1432.45 640.035 1429.39 637.852Z",
    fill: "url(#paint31_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.98 596.74C318.038 599.137 300.716 606.273 306.768 617.437C313.314 629.514 329.519 613.67 333.325 616.946C335.401 618.733 332.653 629.122 340.606 632.557C349.417 636.362 350.436 617.487 359.784 618.771C365.459 619.55 357.718 640.794 366.908 648.941C378.925 659.593 383.885 599.867 397.543 607.03C406.898 611.936 399.338 634.101 412.107 641.817C426.951 650.786 419.711 571.941 434.774 584.142C441.492 589.584 440.129 603.319 446.61 603.277C453.94 603.231 458.164 592.041 458.453 582.405C458.636 576.299 455.133 560.717 458.195 555.859C465.736 543.89 467.305 529.745 459.648 517.434C459.63 517.405 459.612 517.376 459.594 517.347C459.224 515.797 481.393 505.728 476.79 499.597C473.803 495.617 459.332 515.835 456.35 512.979C446.201 501.733 428.243 501.988 420.365 502.23C409.298 502.57 392.933 488.083 388.604 498.116C386.544 502.89 393.913 506.436 391.449 510.99C387.096 519.04 352.38 500.639 345.998 520.412C340.222 538.308 357.437 538.241 356.54 540.956C353.795 549.26 326.072 534.441 322.409 547.204C317.427 564.567 334.956 562.384 331.999 571.985C329.65 579.616 305.531 566.234 303.253 584.02C302.098 593.042 313.922 594.343 315.98 596.74Z",
    fill: "url(#paint32_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.05 356.311C1212.72 377.579 1211.54 379.678 1230.58 404.95C1215.41 394.305 1200.73 394.185 1181.26 389.298L1192.14 402.171C1173.41 403.802 1165.55 409.196 1153.99 422.998L1165.58 434.344C1144.79 445.141 1133.87 450.099 1111.04 447.824L1122.3 455.458C1122.3 455.458 1064.32 490.999 1026.82 475.983C1003.19 466.518 986.587 456.066 974.686 432.39C960.779 431.892 961.715 478.308 952.104 461.055C942.492 443.801 972.379 427.497 972.379 427.497C960.307 400.16 964.438 378.308 975.25 352.205C993.392 308.405 1068.57 302.007 1082.64 298.899C1114.92 291.763 1188.48 339.768 1188.48 339.768C1188.48 339.768 1151.39 335.043 1182.05 356.311Z",
    fill: "url(#paint33_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1305.84 162.093C1325.04 150.893 1296.84 105.269 1296.84 105.269C1296.84 105.269 1341.51 153.24 1355.5 132.46C1363.75 120.199 1354.36 94.3466 1354.36 94.3466C1381.74 136.961 1416.23 204.984 1424.48 203.469C1432.72 201.953 1429.77 164.545 1429.77 164.545L1424.98 110.041C1424.98 110.041 1433.57 118.255 1439.5 118.584C1445.44 118.912 1478.94 72.4202 1478.94 72.4202C1478.94 72.4202 1483.3 122.224 1499.09 116.21C1514.88 110.197 1519 102.331 1519 102.331C1522.43 102.017 1511.69 170.002 1511.69 170.002C1511.69 170.002 1489.81 219.008 1483.51 231.911C1492.24 223.231 1533.2 220.54 1529.43 227.829C1529.43 227.829 1506.8 239.664 1507.78 242.926C1508.76 246.188 1546.37 249.146 1546.37 249.146C1546.37 249.146 1517.9 275.306 1519.78 281.355C1521.67 287.405 1540.92 293.434 1540.92 293.434C1540.92 293.434 1487 297.884 1457.63 317.265C1457.63 317.265 1498.32 372.282 1502.44 381.528C1506.56 390.773 1507.76 396.224 1507.76 396.224C1507.76 396.224 1509.79 421.098 1500.11 422.851C1490.44 424.603 1495.48 396.733 1489.64 381.777C1479.58 356.024 1450.2 322.983 1450.2 322.983C1424.63 345.799 1406.46 395.344 1406.46 395.344C1406.46 395.344 1401.99 370.327 1396.02 371.071C1390.05 371.815 1365.38 398.217 1365.38 398.217C1365.38 398.217 1364.18 362.249 1360.96 359.497C1357.74 356.744 1340.81 368.554 1340.81 368.554C1340.81 368.554 1354.41 327.778 1350.16 328.377C1345.91 328.977 1305.36 336.24 1278.41 328.191C1260.42 322.816 1235.65 305.946 1235.65 305.946C1235.65 305.946 1254.61 300.404 1258.18 290.241C1264.05 273.498 1221.73 262.541 1221.73 262.541C1221.73 262.541 1267.03 267.023 1272.84 246.888C1275.4 238.005 1270.6 223.208 1270.6 223.208C1298.73 246.349 1317.73 254.946 1356.94 262.918C1329.01 218.953 1310.19 196.565 1271.92 159.975C1271.92 159.975 1294.43 168.745 1305.84 162.093Z",
    fill: "url(#paint34_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.207 770C173.598 782.494 202.585 737.36 202.585 737.36C202.585 737.36 178.587 798.364 203.368 802.015C217.991 804.169 237.257 784.536 237.257 784.536C210.629 827.627 164.148 888.094 169.073 894.878C173.998 901.662 206.473 882.86 206.473 882.86L253.575 855.022C253.575 855.022 249.868 866.308 252.134 871.807C254.4 877.307 310.794 887.462 310.794 887.462C310.794 887.462 267.749 912.889 279.987 924.538C292.224 936.186 301.097 936.506 301.097 936.506C302.862 939.47 236.895 959.112 236.895 959.112C236.895 959.112 183.246 960.521 168.887 960.406C180.487 964.539 200.589 1000.33 192.386 1000.07C192.386 1000.07 171.945 984.765 169.424 987.054C166.903 989.343 180.465 1024.55 180.465 1024.55C180.465 1024.55 144.581 1010.16 139.936 1014.47C135.291 1018.77 138.161 1038.75 138.161 1038.75C138.161 1038.75 110.879 992.022 80.7224 973.892C80.7224 973.892 48.6501 1034.34 42.0854 1042.04C35.5206 1049.75 31.1215 1053.18 31.1215 1053.18C31.1215 1053.18 9.55976 1065.75 3.80337 1057.78C-1.95302 1049.8 25.3662 1042.33 36.3367 1030.6C55.2272 1010.41 72.3581 969.655 72.3581 969.655C40.7422 956.434 -11.7949 961.417 -11.7949 961.417C-11.7949 961.417 8.84484 946.592 5.59822 941.528C2.35159 936.465 -32.1101 925.604 -32.1101 925.604C-32.1101 925.604 -0.183 908.996 0.912051 904.907C2.00711 900.817 -15.9548 890.634 -15.9548 890.634C-15.9548 890.634 26.7008 885.315 24.325 881.737C21.9491 878.158 -2.10079 844.711 -6.46746 816.927C-9.3832 798.375 -4.85055 768.757 -4.85055 768.757C-4.85055 768.757 8.32917 783.466 19.0369 782.299C36.6765 780.377 28.3011 737.472 28.3011 737.472C28.3011 737.472 43.8044 780.271 64.4741 776.821C73.5927 775.3 84.8697 764.584 84.8697 764.584C76.1318 799.944 76.5734 820.792 86.3005 859.604C113.913 815.442 125.987 788.802 142.484 738.491C142.484 738.491 144.284 762.58 155.207 770Z",
    fill: "url(#paint35_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M744.957 552.205C756.416 518.531 758.661 519.39 776.886 496.672C771.103 513.348 774.884 527.971 775.541 548.058L784.512 535.311C790.977 553.696 798.027 560.709 813.799 570.142L821.175 556.918C836.627 575.983 844.087 586.103 848.04 609.14L852.087 596.806C852.087 596.806 900.176 649.153 896.284 688.686C893.831 713.604 888.606 731.677 869.958 747.053C873.185 760.958 915.677 753.087 902.337 765.225C888.996 777.363 866.065 750.079 866.065 750.079C844.091 766.172 822.875 765.331 795.975 758.482C750.836 746.99 725.025 673.181 718.436 659.659C703.31 628.619 728.021 548.284 728.021 548.284C728.021 548.284 733.498 585.879 744.957 552.205Z",
    fill: "url(#paint36_linear_3004_95)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.732 278.207C378.593 278.207 366.889 268.228 366.889 251.596C366.889 229.79 383.521 216.607 399.906 216.607C412.473 216.607 417.524 223.137 417.524 229.42C417.524 240.631 404.588 248.023 382.905 252.089C383.644 261.329 390.05 268.474 400.522 268.474C413.705 268.474 421.22 261.945 424.546 256.77C426.148 256.77 427.01 257.756 426.517 259.974C425.409 265.394 413.581 278.207 394.732 278.207ZM400.029 222.767C393.007 222.767 384.383 230.898 383.028 246.298C398.058 242.726 404.341 235.21 404.341 227.079C404.341 224.492 402.617 222.767 400.029 222.767ZM487.153 247.777C493.19 247.777 496.147 246.545 496.147 246.545C497.379 247.407 497.132 248.886 495.777 250.118C493.929 251.842 490.11 252.705 485.428 252.705C478.529 252.705 473.724 249.871 473.724 249.871C471.999 254.306 469.412 260.466 466.209 265.148C461.158 272.417 454.259 278.207 445.019 278.207C432.575 278.207 424.937 269.09 424.937 254.799C424.937 247.9 425.676 241.37 426.785 234.471L427.771 228.311C429.003 220.303 427.894 217.716 427.894 217.716C427.894 217.716 429.742 216.607 434.3 216.607C443.787 216.607 444.895 220.303 443.417 228.804L441.569 239.276C440.83 243.588 440.214 248.393 440.214 252.089C440.214 262.191 443.663 267.489 450.439 267.489C458.078 267.489 465.347 258.988 467.564 243.958C464.238 238.906 462.143 232.377 462.143 225.724C462.143 220.55 465.347 216.607 470.521 216.607C474.71 216.607 478.283 219.071 478.283 225.847C478.283 231.391 477.297 237.921 475.695 243.958C475.695 243.958 478.652 247.777 487.153 247.777ZM515.044 278.207C498.905 278.207 487.201 268.228 487.201 251.596C487.201 229.79 503.833 216.607 520.219 216.607C532.785 216.607 537.836 223.137 537.836 229.42C537.836 240.631 524.9 248.023 503.217 252.089C503.956 261.329 510.363 268.474 520.835 268.474C534.017 268.474 541.532 261.945 544.859 256.77C546.46 256.77 547.323 257.756 546.83 259.974C545.721 265.394 533.894 278.207 515.044 278.207ZM520.342 222.767C513.32 222.767 504.696 230.898 503.34 246.298C518.371 242.726 524.654 235.21 524.654 227.079C524.654 224.492 522.929 222.767 520.342 222.767ZM582.949 248.762L585.29 235.21C586.275 229.297 585.043 227.449 582.333 227.449C574.571 227.449 562.867 245.806 559.048 266.503C557.693 274.265 558.925 277.098 558.925 277.098C558.925 277.098 557.077 278.207 552.518 278.207C543.032 278.207 541.923 274.634 543.402 266.01L549.931 228.311C551.286 220.55 550.054 217.716 550.054 217.716C550.054 217.716 551.902 216.607 556.461 216.607C565.947 216.607 567.056 220.18 565.578 228.804L564.592 234.471C569.397 226.463 578.76 216.607 588.739 216.607C596.501 216.607 601.429 221.658 601.429 229.297C601.429 232.007 600.936 235.58 600.32 239.276L597.363 256.647C596.254 262.684 597.24 267.489 602.414 267.489C607.589 267.489 612.147 263.177 615.35 256.77C616.952 256.77 618.061 257.756 617.691 259.974C616.706 266.257 607.466 278.207 596.008 278.207C586.768 278.207 581.101 272.047 581.101 262.807C581.101 259.604 582.21 252.828 582.949 248.762ZM615.269 251.103L619.211 228.311C620.566 220.426 619.334 217.716 619.334 217.716C619.334 217.716 621.182 216.607 625.741 216.607C635.227 216.607 636.336 220.18 634.857 228.804L630.053 256.647C628.821 264.039 630.915 267.489 635.35 267.489C639.539 267.489 645.083 263.423 648.286 256.77C649.888 256.77 650.997 257.756 650.627 259.974C649.395 266.503 640.525 278.207 628.574 278.207C620.073 278.207 614.16 272.663 614.16 262.807C614.16 260.343 614.406 256.031 615.269 251.103ZM623.523 198.127C623.523 193.076 627.465 189.257 632.147 189.257C636.829 189.257 639.785 192.583 639.785 197.018C639.785 201.33 636.336 205.519 630.915 205.519C626.48 205.519 623.523 202.439 623.523 198.127ZM685.936 248.762L688.277 235.21C689.263 229.297 688.031 227.449 685.32 227.449C677.559 227.449 665.855 245.806 662.035 266.503C660.68 274.265 661.912 277.098 661.912 277.098C661.912 277.098 660.064 278.207 655.506 278.207C646.019 278.207 644.911 274.634 646.389 266.01L652.919 228.311C654.274 220.55 653.042 217.716 653.042 217.716C653.042 217.716 654.89 216.607 659.448 216.607C668.935 216.607 670.043 220.18 668.565 228.804L667.579 234.471C672.384 226.463 681.747 216.607 691.727 216.607C699.488 216.607 704.416 221.658 704.416 229.297C704.416 232.007 703.923 235.58 703.307 239.276L700.351 256.647C699.242 262.684 700.227 267.489 705.402 267.489C710.576 267.489 715.135 263.177 718.338 256.77C719.939 256.77 721.048 257.756 720.679 259.974C719.693 266.257 710.453 278.207 698.995 278.207C689.755 278.207 684.088 272.047 684.088 262.807C684.088 259.604 685.197 252.828 685.936 248.762ZM774.066 226.71L765.442 276.852C760.514 305.311 749.179 321.327 730.946 321.327C722.568 321.327 717.147 316.03 717.147 308.391C717.147 301.122 721.459 294.47 727.496 289.295C733.533 283.998 739.939 280.302 750.042 275.374L751.52 266.626C746.592 274.265 740.432 278.207 734.026 278.207C723.923 278.207 715.915 271.431 715.915 257.017C715.915 229.543 731.931 216.607 746.346 216.607C752.506 216.607 756.818 219.071 759.651 222.644C761.622 218.209 764.702 216.607 770.739 216.607C774.928 216.607 776.899 217.839 776.899 217.839C776.899 217.839 775.174 220.057 774.066 226.71ZM729.714 313.196C738.338 313.196 744.99 302.847 748.686 283.135C740.555 287.324 734.888 290.897 731.315 294.47C726.51 299.151 724.046 303.34 724.046 307.652C724.046 310.855 725.894 313.196 729.714 313.196ZM738.954 267.489C747.701 267.489 754.23 249.009 756.571 236.689L757.68 230.898C756.571 228.434 754.23 224.985 749.549 224.985C741.171 224.985 731.685 237.428 731.685 257.263C731.685 264.162 734.395 267.489 738.954 267.489Z",
    fill: "#2B2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.663 259.979C862.707 259.979 860.144 258.993 858.173 257.614C856.891 261.457 855.413 264.907 853.836 267.371C849.302 274.665 844.374 279.79 836.49 279.79C829.492 279.79 824.761 275.552 822.888 268.849C819.044 275.059 813.722 279.79 806.823 279.79C796.967 279.79 792.335 272.89 792.335 261.556C792.335 256.727 792.926 251.109 793.912 244.801L794.7 239.873C795.686 233.664 794.799 231.397 794.799 231.397C794.799 231.397 796.277 230.51 799.924 230.51C807.513 230.51 808.4 233.368 807.217 240.267L805.837 248.25C804.95 253.277 804.655 257.417 804.655 260.57C804.655 268.652 807.217 271.215 811.455 271.215C816.285 271.215 820.03 265.893 822.1 257.712C822.297 253.671 822.79 249.039 823.48 244.801L824.268 239.873C825.352 233.664 824.367 231.397 824.367 231.397C824.367 231.397 825.845 230.51 829.492 230.51C837.081 230.51 837.968 233.368 836.785 240.267L835.405 248.25C834.42 253.77 834.124 257.614 834.124 260.965C834.124 268.258 836.588 271.215 841.023 271.215C846.838 271.215 851.668 263.823 853.146 252.39C850.387 248.349 848.81 243.52 848.81 237.803C848.81 233.565 851.471 230.51 855.512 230.51C858.961 230.51 861.721 232.678 861.721 237.902C861.721 242.337 860.932 247.561 859.651 252.39C861.031 254.263 863.199 255.642 866.353 255.642C873.844 255.642 876.899 247.856 876.899 247.856C878.476 247.856 878.87 249.236 878.673 250.32C878.082 253.77 873.745 259.979 865.663 259.979ZM870.776 258.106L873.93 239.873C875.014 233.565 874.029 231.397 874.029 231.397C874.029 231.397 875.507 230.51 879.154 230.51C886.743 230.51 887.63 233.368 886.447 240.267L882.603 262.542C881.618 268.455 883.293 271.215 886.841 271.215C890.192 271.215 894.628 267.962 897.19 262.64C898.471 262.64 899.359 263.429 899.063 265.203C898.077 270.426 890.981 279.79 881.421 279.79C874.62 279.79 869.889 275.354 869.889 267.47C869.889 265.498 870.086 262.049 870.776 258.106ZM877.38 215.726C877.38 211.685 880.534 208.629 884.279 208.629C888.024 208.629 890.39 211.29 890.39 214.839C890.39 218.288 887.63 221.639 883.293 221.639C879.745 221.639 877.38 219.175 877.38 215.726ZM897.545 230.51H902.177L903.163 225.187C904.346 218.978 903.262 216.711 903.262 216.711C903.262 216.711 904.74 215.824 908.387 215.824C915.976 215.824 916.961 218.682 915.68 225.582L914.793 230.51H924.551C924.551 230.51 925.241 231.298 925.241 232.579C925.241 234.255 924.058 235.438 921.889 235.438H913.906L909.175 262.542C908.19 267.962 910.161 271.215 914.793 271.215C920.411 271.215 924.452 266.78 926.62 262.64C927.902 262.64 928.789 263.527 928.394 265.203C926.916 271.215 918.933 279.79 909.569 279.79C902.276 279.79 896.56 274.665 896.56 266.78C896.56 264.513 896.757 261.26 897.644 256.234L901.29 235.438H894.884C894.884 235.438 894.194 234.649 894.194 233.368C894.194 231.692 895.377 230.51 897.545 230.51ZM972.239 271.215C976.083 271.215 979.73 268.357 982.588 262.64C983.869 262.64 984.756 263.429 984.46 265.203C983.475 270.426 976.28 279.79 967.114 279.79C959.722 279.79 955.188 274.862 955.188 267.47C955.188 264.907 955.878 261.063 956.667 256.234L958.539 245.392C959.328 240.661 958.342 239.183 956.174 239.183C949.964 239.183 940.503 253.868 937.546 270.426C936.462 276.636 937.447 278.903 937.447 278.903C937.447 278.903 935.969 279.79 932.322 279.79C924.733 279.79 923.846 276.931 925.029 270.032L935.969 207.348C937.053 201.139 936.068 198.872 936.068 198.872C936.068 198.872 937.546 197.985 941.193 197.985C948.782 197.985 949.669 200.843 948.486 207.742L941.981 244.801C945.825 238.394 953.217 230.51 961.299 230.51C967.508 230.51 971.451 234.551 971.451 240.661C971.451 242.83 971.056 245.688 970.564 248.645L968.198 262.542C967.212 268.061 968.494 271.215 972.239 271.215Z",
    fill: "#2B2133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.569 363.884L536.511 341.092C537.866 333.207 536.634 330.497 536.634 330.497C536.634 330.497 538.482 329.388 543.041 329.388C552.527 329.388 553.636 332.961 552.158 341.585L547.353 369.428C546.121 376.82 548.215 380.27 552.65 380.27C556.839 380.27 562.383 376.204 565.586 369.551C567.188 369.551 568.297 370.537 567.927 372.754C566.695 379.284 557.825 390.988 545.874 390.988C537.374 390.988 531.46 385.444 531.46 375.588C531.46 373.124 531.706 368.812 532.569 363.884ZM540.823 310.908C540.823 305.857 544.766 302.038 549.447 302.038C554.129 302.038 557.086 305.364 557.086 309.799C557.086 314.111 553.636 318.3 548.215 318.3C543.78 318.3 540.823 315.22 540.823 310.908ZM603.237 361.543L605.577 347.991C606.563 342.078 605.331 340.23 602.621 340.23C594.859 340.23 583.155 358.586 579.336 379.284C577.981 387.046 579.213 389.879 579.213 389.879C579.213 389.879 577.365 390.988 572.806 390.988C563.32 390.988 562.211 387.415 563.689 378.791L570.219 341.092C571.574 333.33 570.342 330.497 570.342 330.497C570.342 330.497 572.19 329.388 576.749 329.388C586.235 329.388 587.344 332.961 585.865 341.585L584.88 347.252C589.685 339.244 599.048 329.388 609.027 329.388C616.789 329.388 621.717 334.439 621.717 342.078C621.717 344.788 621.224 348.361 620.608 352.057L617.651 369.428C616.542 375.465 617.528 380.27 622.702 380.27C627.877 380.27 632.435 375.958 635.638 369.551C637.24 369.551 638.349 370.537 637.979 372.754C636.993 379.038 627.753 390.988 616.296 390.988C607.056 390.988 601.389 384.828 601.389 375.588C601.389 372.385 602.497 365.609 603.237 361.543ZM684.713 390.988C676.582 390.988 670.792 385.937 670.299 376.943C665.124 386.06 658.472 390.988 651.326 390.988C641.224 390.988 633.216 384.212 633.216 369.798C633.216 342.324 649.232 329.388 663.646 329.388C669.436 329.388 673.625 331.482 676.459 334.809L682.372 300.436C683.728 292.674 682.496 289.841 682.496 289.841C682.496 289.841 684.344 288.732 688.902 288.732C698.388 288.732 699.497 292.305 698.019 300.929L686.192 369.428C684.96 376.82 687.054 380.27 691.489 380.27C695.678 380.27 701.222 376.204 704.425 369.551C706.027 369.551 707.136 370.537 706.766 372.754C705.534 379.284 696.664 390.988 684.713 390.988ZM656.254 380.27C665.001 380.27 671.531 361.79 673.872 349.47L674.98 343.679C673.872 341.215 671.531 337.766 666.849 337.766C658.472 337.766 648.985 350.209 648.985 370.044C648.985 376.943 651.696 380.27 656.254 380.27ZM739.367 375.588C739.367 374.479 739.367 373.124 739.49 371.399C737.765 374.849 735.917 377.929 733.946 380.516C728.772 387.538 723.351 390.988 716.575 390.988C708.32 390.988 703.146 385.198 703.146 376.697C703.146 372.138 703.516 367.95 704.624 361.543L708.197 341.092C709.552 333.33 708.32 330.497 708.32 330.497C708.32 330.497 710.168 329.388 714.727 329.388C724.213 329.388 725.322 332.961 723.844 341.585L718.916 370.044C717.684 377.066 719.408 380.27 722.981 380.27C725.692 380.27 728.895 376.943 732.098 372.015C737.396 364.007 742.693 350.825 744.541 339.86C745.65 333.084 744.541 330.497 744.541 330.497C744.541 330.497 746.389 329.388 750.948 329.388C760.434 329.388 761.543 332.961 760.064 341.585L755.26 369.428C754.028 376.82 756.122 380.27 760.557 380.27C764.746 380.27 770.29 376.204 773.493 369.551C775.095 369.551 776.204 370.537 775.834 372.754C774.602 379.284 765.732 390.988 753.781 390.988C745.28 390.988 739.367 385.444 739.367 375.588ZM794.258 351.071L804.853 356.615C813.847 361.297 817.05 366.348 817.05 372.878C817.05 382.61 808.796 390.988 790.932 390.988C775.162 390.988 768.509 382.857 768.509 376.45C768.509 371.769 772.329 369.058 776.641 369.058C780.829 369.058 782.554 370.783 782.554 370.783C782.554 370.783 781.938 372.138 781.938 374.356C781.938 380.393 785.141 384.705 792.164 384.828C799.186 384.828 802.513 381.132 802.513 377.066C802.513 374.11 800.911 371.646 796.476 369.305L784.402 362.898C778.489 359.695 773.684 355.753 773.684 347.498C773.684 337.519 782.308 329.388 799.802 329.388C815.079 329.388 822.225 337.519 822.225 343.926C822.225 348.607 818.405 351.318 814.093 351.318C809.905 351.318 808.18 349.593 808.18 349.593C808.18 349.593 808.796 348.238 808.796 346.02C808.796 340.23 805.223 335.548 798.324 335.548C791.548 335.548 788.221 338.998 788.221 343.31C788.221 346.882 790.193 348.977 794.258 351.071ZM830.116 329.388H835.907L837.139 322.735C838.617 314.974 837.262 312.14 837.262 312.14C837.262 312.14 839.11 311.031 843.668 311.031C853.155 311.031 854.387 314.604 852.785 323.228L851.676 329.388H863.873C863.873 329.388 864.735 330.374 864.735 331.975C864.735 334.07 863.257 335.548 860.547 335.548H850.567L844.654 369.428C843.422 376.204 845.886 380.27 851.676 380.27C858.699 380.27 863.75 374.726 866.46 369.551C868.062 369.551 869.171 370.66 868.678 372.754C866.83 380.27 856.851 390.988 845.147 390.988C836.03 390.988 828.884 384.582 828.884 374.726C828.884 371.892 829.131 367.826 830.239 361.543L834.798 335.548H826.79C826.79 335.548 825.927 334.562 825.927 332.961C825.927 330.866 827.406 329.388 830.116 329.388ZM886.647 341.585L885.661 347.006C893.546 333.7 901.8 329.388 907.344 329.388C913.381 329.388 917.2 332.714 917.2 338.998C917.2 345.897 913.011 350.825 906.975 350.825C903.771 350.825 901.431 350.086 901.431 350.086C901.431 350.086 903.032 347.252 903.032 343.926C903.032 342.201 902.293 341.215 900.445 341.215C898.474 341.215 895.763 342.817 891.698 348.484C887.016 355.014 882.951 362.652 879.994 380.023C878.762 387.292 879.994 389.879 879.994 389.879C879.994 389.879 878.146 390.988 873.587 390.988C864.101 390.988 862.992 387.415 864.471 378.791L871 341.092C872.355 333.33 871.123 330.497 871.123 330.497C871.123 330.497 872.971 329.388 877.53 329.388C887.016 329.388 888.125 333.33 886.647 341.585ZM976.504 341.585L969.851 380.639C969.851 380.639 982.54 375.588 989.932 369.551C991.534 369.551 992.643 370.66 992.273 372.385C992.027 373.617 990.672 374.972 988.208 376.82C983.649 380.27 975.888 384.582 968.619 388.154L968.372 389.633C963.568 418.215 952.11 434.108 933.876 434.108C925.499 434.108 920.078 428.811 920.078 421.172C920.078 413.903 924.39 407.251 930.427 402.076C936.587 396.779 942.993 393.083 952.972 388.154L955.56 372.262C953.958 375.342 952.233 378.052 950.508 380.516C945.334 387.538 939.913 390.988 933.137 390.988C924.883 390.988 919.708 385.198 919.708 376.697C919.708 372.138 920.078 367.95 921.187 361.543L924.76 341.092C926.115 333.33 924.883 330.497 924.883 330.497C924.883 330.497 926.731 329.388 931.289 329.388C940.776 329.388 941.884 332.961 940.406 341.585L935.478 370.044C934.246 377.19 935.971 380.27 939.544 380.27C942.254 380.27 945.457 376.943 948.66 372.015C953.465 364.623 958.393 353.412 960.857 341.092C962.336 333.33 960.98 330.497 960.98 330.497C960.98 330.497 962.828 329.388 967.387 329.388C976.873 329.388 977.982 332.961 976.504 341.585ZM932.645 425.977C941.392 425.977 948.044 415.628 951.617 395.916C943.486 400.105 937.942 403.678 934.246 407.251C929.441 411.932 926.977 416.121 926.977 420.433C926.977 423.636 928.825 425.977 932.645 425.977Z",
    fill: "#2B2133"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1012.82 222.703C1014.05 215.065 1019.23 212.847 1026.62 212.847C1038.94 212.847 1060.13 218.514 1093.15 218.514C1107.44 218.514 1116.31 214.572 1116.31 214.572C1117.54 215.804 1119.27 218.761 1119.27 224.674C1119.27 238.719 1110.64 246.85 1089.94 246.85C1066.78 246.85 1044.61 237.241 1025.63 233.545L1015.78 291.695C1024.89 287.506 1035 285.042 1048.3 285.042C1082.31 285.042 1101.03 305.986 1101.03 332.844C1101.03 372.268 1073.44 397.647 1034.75 397.647C1004.94 397.647 988.92 380.153 985.224 361.18C983.746 353.788 987.688 347.628 993.602 349.106C995.573 365.615 1007.4 376.21 1025.88 376.21C1050.77 376.21 1066.78 357.238 1066.78 330.873C1066.78 311.9 1055.94 300.073 1038.94 300.073C1018.73 300.073 1008.88 314.118 1008.88 314.118C1001.98 314.118 997.79 310.422 999.022 303.522L1012.82 222.703ZM1187.86 212.847C1225.07 212.847 1242.07 238.966 1242.07 277.897C1242.07 343.193 1212.01 397.647 1162.98 397.647C1130.21 397.647 1109.51 374.732 1109.51 332.598C1109.51 264.838 1141.54 212.847 1187.86 212.847ZM1187.62 226.399C1177.52 226.399 1167.41 236.502 1160.27 254.489C1151.64 276.418 1143.76 313.132 1143.76 348.86C1143.76 373.5 1150.9 384.095 1163.96 384.095C1173.82 384.095 1183.68 374.732 1191.31 356.006C1200.18 334.322 1207.82 297.855 1207.82 261.634C1207.82 235.516 1199.69 226.399 1187.62 226.399Z",
    fill: "#2B2133"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560.147 427.239C559.658 427.239 559.208 427.089 558.795 426.789C558.419 426.488 558.232 426.057 558.232 425.493V404.092C558.232 403.454 558.419 402.984 558.795 402.684C559.208 402.346 559.658 402.177 560.147 402.177C560.635 402.177 561.066 402.346 561.442 402.684C561.855 402.984 562.061 403.454 562.061 404.092V412.146C562.662 411.507 563.451 411 564.427 410.625C565.441 410.249 566.379 410.062 567.243 410.062C569.195 410.062 570.847 410.738 572.199 412.089C573.588 413.441 574.283 415.431 574.283 418.059V425.493C574.283 426.057 574.076 426.488 573.663 426.789C573.25 427.089 572.819 427.239 572.368 427.239C571.88 427.239 571.429 427.089 571.016 426.789C570.641 426.488 570.453 426.057 570.453 425.493V418.397C570.453 416.745 570.078 415.525 569.327 414.736C568.613 413.948 567.656 413.554 566.454 413.554C564.84 413.554 563.695 414.06 563.019 415.074C562.381 416.05 562.061 417.139 562.061 418.341V425.493C562.061 426.057 561.855 426.488 561.442 426.789C561.066 427.089 560.635 427.239 560.147 427.239ZM585.792 427.239C584.177 427.239 582.732 426.864 581.455 426.113C580.179 425.362 579.184 424.329 578.47 423.015C577.757 421.664 577.4 420.162 577.4 418.51C577.4 416.895 577.757 415.45 578.47 414.173C579.184 412.897 580.179 411.902 581.455 411.188C582.732 410.437 584.177 410.062 585.792 410.062C586.843 410.062 587.782 410.249 588.608 410.625C589.434 410.963 590.147 411.413 590.748 411.977C590.823 411.451 591.049 411.057 591.424 410.794C591.799 410.494 592.212 410.343 592.663 410.343C593.151 410.343 593.583 410.512 593.958 410.85C594.371 411.151 594.578 411.62 594.578 412.258V425.493C594.578 426.057 594.371 426.488 593.958 426.789C593.583 427.089 593.151 427.239 592.663 427.239C592.175 427.239 591.724 427.089 591.311 426.789C590.936 426.488 590.748 426.057 590.748 425.493V425.268C590.147 425.869 589.434 426.338 588.608 426.676C587.782 427.052 586.843 427.239 585.792 427.239ZM586.13 423.748C587.557 423.748 588.683 423.278 589.509 422.34C590.335 421.363 590.748 420.087 590.748 418.51C590.748 417.008 590.335 415.806 589.509 414.905C588.683 414.004 587.557 413.554 586.13 413.554C584.666 413.554 583.483 414.004 582.582 414.905C581.681 415.806 581.23 417.008 581.23 418.51C581.23 420.087 581.681 421.363 582.582 422.34C583.483 423.278 584.666 423.748 586.13 423.748ZM602.651 418.341V425.493C602.651 426.057 602.445 426.488 602.032 426.789C601.656 427.089 601.225 427.239 600.737 427.239C600.248 427.239 599.798 427.089 599.385 426.789C599.009 426.488 598.822 426.057 598.822 425.493V412.258C598.822 411.62 599.009 411.151 599.385 410.85C599.798 410.512 600.248 410.343 600.737 410.343C601.225 410.343 601.656 410.512 602.032 410.85C602.445 411.151 602.651 411.62 602.651 412.258V412.484C603.177 411.77 603.853 411.188 604.679 410.738C605.543 410.287 606.444 410.062 607.382 410.062C607.833 410.062 608.283 410.118 608.734 410.231C609.185 410.343 609.523 410.569 609.748 410.907C609.973 411.244 610.086 411.62 610.086 412.033C610.086 412.521 609.917 412.972 609.579 413.385C609.278 413.76 608.828 413.948 608.227 413.948C607.964 413.948 607.683 413.91 607.382 413.835C607.12 413.76 606.782 413.723 606.369 413.723C605.28 413.723 604.379 414.136 603.665 414.962C602.989 415.788 602.651 416.914 602.651 418.341ZM619.272 427.239C618.709 427.239 618.184 427.108 617.696 426.845C617.207 426.62 616.851 426.263 616.625 425.775L611.05 412.652C610.975 412.352 610.937 412.127 610.937 411.977C610.937 411.376 611.144 410.907 611.557 410.569C611.97 410.231 612.42 410.062 612.908 410.062C613.246 410.062 613.565 410.156 613.866 410.343C614.204 410.531 614.448 410.831 614.598 411.244L618.54 421.438C618.728 421.814 618.972 422.002 619.272 422.002C619.648 422.002 619.892 421.814 620.005 421.438L623.891 411.244C624.041 410.831 624.266 410.531 624.567 410.343C624.904 410.156 625.242 410.062 625.58 410.062C626.106 410.062 626.557 410.231 626.932 410.569C627.345 410.907 627.552 411.357 627.552 411.92C627.552 412.108 627.514 412.352 627.439 412.652L621.92 425.775C621.694 426.263 621.338 426.62 620.849 426.845C620.361 427.108 619.836 427.239 619.272 427.239ZM637.67 427.239C634.854 427.239 632.658 426.432 631.081 424.818C629.504 423.203 628.715 421.025 628.715 418.284C628.715 415.881 629.504 413.91 631.081 412.371C632.695 410.831 634.76 410.062 637.276 410.062C639.716 410.062 641.669 410.775 643.133 412.202C644.598 413.591 645.33 415.318 645.33 417.383C645.33 418.209 645.104 418.829 644.654 419.242C644.241 419.655 643.696 419.861 643.021 419.861H633.221C632.845 419.861 632.714 420.068 632.827 420.481C633.127 421.532 633.728 422.358 634.629 422.959C635.568 423.522 636.619 423.804 637.783 423.804C638.646 423.804 639.472 423.691 640.261 423.466C641.087 423.241 641.8 422.903 642.401 422.452C642.589 422.302 642.833 422.227 643.133 422.227C643.546 422.227 643.922 422.415 644.26 422.79C644.598 423.128 644.767 423.541 644.767 424.029C644.767 424.254 644.729 424.48 644.654 424.705C644.579 424.93 644.41 425.156 644.147 425.381C643.171 426.094 642.119 426.582 640.993 426.845C639.904 427.108 638.797 427.239 637.67 427.239ZM640.937 416.933C641.162 416.933 641.275 416.82 641.275 416.595C641.275 415.731 640.88 414.98 640.092 414.342C639.341 413.704 638.402 413.385 637.276 413.385C636.3 413.385 635.361 413.647 634.46 414.173C633.596 414.699 633.071 415.393 632.883 416.257C632.883 416.257 632.883 416.276 632.883 416.313C632.845 416.463 632.827 416.595 632.827 416.708C632.864 416.82 633.033 416.876 633.334 416.876L640.937 416.933ZM654.564 427.239C653.475 427.239 652.368 427.089 651.241 426.789C650.115 426.526 649.12 426.094 648.256 425.493C647.806 425.08 647.58 424.63 647.58 424.142C647.58 423.654 647.768 423.222 648.144 422.846C648.557 422.471 649.007 422.283 649.495 422.283C649.758 422.283 650.021 422.358 650.284 422.508C650.96 422.921 651.729 423.259 652.593 423.522C653.494 423.748 654.339 423.86 655.127 423.86C655.878 423.86 656.516 423.729 657.042 423.466C657.605 423.203 657.887 422.771 657.887 422.171C657.887 421.57 657.624 421.119 657.098 420.819C656.573 420.518 655.672 420.293 654.395 420.143C653.869 420.068 653.231 419.974 652.48 419.861C651.767 419.749 651.053 419.542 650.34 419.242C649.627 418.942 649.026 418.491 648.538 417.89C648.05 417.289 647.806 416.482 647.806 415.468C647.806 413.816 648.406 412.502 649.608 411.526C650.847 410.55 652.499 410.062 654.564 410.062C655.765 410.062 656.892 410.212 657.943 410.512C659.032 410.813 659.839 411.188 660.365 411.639C660.778 411.977 660.984 412.371 660.984 412.821C660.984 413.31 660.816 413.741 660.478 414.117C660.14 414.492 659.727 414.68 659.239 414.68C658.976 414.68 658.732 414.624 658.506 414.511C657.906 414.173 657.23 413.929 656.479 413.779C655.765 413.591 655.071 413.497 654.395 413.497C653.607 413.497 652.931 413.629 652.368 413.892C651.842 414.117 651.579 414.492 651.579 415.018C651.579 415.393 651.729 415.731 652.03 416.032C652.368 416.294 653.212 416.52 654.564 416.708C655.202 416.783 655.916 416.895 656.704 417.045C657.53 417.196 658.319 417.44 659.07 417.778C659.821 418.078 660.44 418.566 660.928 419.242C661.416 419.918 661.66 420.838 661.66 422.002C661.66 423.203 661.322 424.198 660.647 424.987C659.971 425.737 659.088 426.301 658 426.676C656.948 427.052 655.803 427.239 654.564 427.239ZM671.406 427.239C669.942 427.239 668.74 426.789 667.801 425.888C666.863 424.987 666.393 423.635 666.393 421.833V414.68C666.393 414.305 666.206 414.117 665.83 414.117H664.816C664.328 414.117 663.915 413.967 663.577 413.666C663.239 413.328 663.071 412.915 663.071 412.427C663.071 411.902 663.239 411.47 663.577 411.132C663.915 410.794 664.328 410.625 664.816 410.625H665.83C666.206 410.625 666.393 410.437 666.393 410.062V405.331C666.393 404.805 666.562 404.392 666.9 404.092C667.276 403.754 667.726 403.585 668.252 403.585C668.815 403.585 669.266 403.754 669.604 404.092C669.979 404.392 670.167 404.805 670.167 405.331V410.062C670.167 410.437 670.355 410.625 670.73 410.625H673.771C674.222 410.625 674.616 410.794 674.954 411.132C675.292 411.47 675.461 411.902 675.461 412.427C675.461 412.915 675.292 413.328 674.954 413.666C674.654 413.967 674.241 414.117 673.715 414.117H670.73C670.355 414.117 670.167 414.305 670.167 414.68V421.326C670.167 422.903 670.805 423.691 672.082 423.691C672.457 423.691 672.851 423.635 673.264 423.522C673.677 423.41 673.959 423.353 674.109 423.353C674.635 423.353 675.029 423.522 675.292 423.86C675.592 424.198 675.743 424.592 675.743 425.043C675.743 425.381 675.649 425.719 675.461 426.057C675.273 426.357 674.973 426.582 674.56 426.732C674.147 426.883 673.621 426.995 672.983 427.07C672.382 427.183 671.856 427.239 671.406 427.239ZM688.157 411.977C688.157 411.376 688.364 410.907 688.777 410.569C689.19 410.231 689.64 410.062 690.128 410.062C690.917 410.062 691.48 410.456 691.818 411.244L696.211 422.002C696.324 422.302 696.53 422.452 696.83 422.452C697.131 422.452 697.337 422.321 697.45 422.058L701.223 411.301C701.524 410.475 702.106 410.062 702.969 410.062C703.495 410.062 703.964 410.231 704.377 410.569C704.828 410.907 705.053 411.32 705.053 411.808C705.053 411.995 704.997 412.258 704.884 412.596L696.267 433.604C695.967 434.43 695.385 434.843 694.521 434.843C694.033 434.843 693.564 434.674 693.113 434.336C692.7 433.998 692.494 433.585 692.494 433.097C692.494 432.721 692.55 432.458 692.663 432.308L695.422 426.676C694.634 426.601 694.089 426.226 693.789 425.55L688.27 412.652C688.195 412.352 688.157 412.127 688.157 411.977ZM714.94 427.239C713.288 427.239 711.786 426.864 710.434 426.113C709.12 425.362 708.088 424.329 707.337 423.015C706.586 421.664 706.21 420.162 706.21 418.51C706.21 416.895 706.586 415.45 707.337 414.173C708.088 412.897 709.12 411.902 710.434 411.188C711.786 410.437 713.288 410.062 714.94 410.062C716.592 410.062 718.075 410.437 719.389 411.188C720.703 411.902 721.736 412.897 722.487 414.173C723.275 415.45 723.67 416.895 723.67 418.51C723.67 420.162 723.275 421.664 722.487 423.015C721.736 424.329 720.703 425.362 719.389 426.113C718.075 426.864 716.592 427.239 714.94 427.239ZM714.94 423.748C716.404 423.748 717.587 423.278 718.488 422.34C719.389 421.363 719.84 420.087 719.84 418.51C719.84 417.008 719.389 415.806 718.488 414.905C717.587 414.004 716.404 413.554 714.94 413.554C713.438 413.554 712.237 414.004 711.335 414.905C710.472 415.806 710.04 417.008 710.04 418.51C710.04 420.087 710.472 421.363 711.335 422.34C712.237 423.278 713.438 423.748 714.94 423.748ZM738.685 411.92C738.685 411.395 738.854 410.963 739.192 410.625C739.567 410.249 740.037 410.062 740.6 410.062C741.126 410.062 741.576 410.249 741.952 410.625C742.327 410.963 742.515 411.395 742.515 411.92V419.861C742.515 421.551 742.139 422.94 741.388 424.029C740.637 425.118 739.661 425.925 738.46 426.451C737.258 426.977 735.982 427.239 734.63 427.239C733.278 427.239 732.002 426.977 730.8 426.451C729.599 425.925 728.622 425.118 727.872 424.029C727.121 422.94 726.745 421.551 726.745 419.861V411.92C726.745 411.395 726.914 410.963 727.252 410.625C727.627 410.249 728.097 410.062 728.66 410.062C729.186 410.062 729.636 410.249 730.012 410.625C730.387 410.963 730.575 411.395 730.575 411.92V419.861C730.575 421.251 730.988 422.246 731.814 422.846C732.64 423.447 733.579 423.748 734.63 423.748C735.719 423.748 736.657 423.447 737.446 422.846C738.272 422.246 738.685 421.251 738.685 419.861V411.92ZM750.546 418.341V425.493C750.546 426.057 750.34 426.488 749.927 426.789C749.551 427.089 749.12 427.239 748.632 427.239C748.144 427.239 747.693 427.089 747.28 426.789C746.904 426.488 746.717 426.057 746.717 425.493V412.258C746.717 411.62 746.904 411.151 747.28 410.85C747.693 410.512 748.144 410.343 748.632 410.343C749.12 410.343 749.551 410.512 749.927 410.85C750.34 411.151 750.546 411.62 750.546 412.258V412.484C751.072 411.77 751.748 411.188 752.574 410.738C753.438 410.287 754.339 410.062 755.277 410.062C755.728 410.062 756.178 410.118 756.629 410.231C757.08 410.343 757.418 410.569 757.643 410.907C757.868 411.244 757.981 411.62 757.981 412.033C757.981 412.521 757.812 412.972 757.474 413.385C757.173 413.76 756.723 413.948 756.122 413.948C755.859 413.948 755.578 413.91 755.277 413.835C755.015 413.76 754.677 413.723 754.264 413.723C753.175 413.723 752.274 414.136 751.56 414.962C750.884 415.788 750.546 416.914 750.546 418.341ZM780.583 427.239C779.531 427.239 778.593 427.052 777.767 426.676C776.941 426.338 776.227 425.869 775.626 425.268V433.097C775.626 433.66 775.42 434.092 775.007 434.392C774.632 434.692 774.2 434.843 773.712 434.843C773.224 434.843 772.773 434.692 772.36 434.392C771.984 434.092 771.797 433.66 771.797 433.097V412.258C771.797 411.62 771.984 411.151 772.36 410.85C772.773 410.512 773.224 410.343 773.712 410.343C774.162 410.343 774.575 410.494 774.951 410.794C775.326 411.057 775.551 411.451 775.626 411.977C776.227 411.413 776.941 410.963 777.767 410.625C778.593 410.249 779.531 410.062 780.583 410.062C782.235 410.062 783.68 410.437 784.919 411.188C786.196 411.902 787.191 412.897 787.904 414.173C788.618 415.45 788.974 416.895 788.974 418.51C788.974 420.162 788.618 421.664 787.904 423.015C787.191 424.329 786.196 425.362 784.919 426.113C783.68 426.864 782.235 427.239 780.583 427.239ZM780.245 423.748C781.709 423.748 782.892 423.278 783.793 422.34C784.694 421.363 785.145 420.087 785.145 418.51C785.145 417.008 784.694 415.806 783.793 414.905C782.892 414.004 781.709 413.554 780.245 413.554C778.818 413.554 777.692 414.004 776.866 414.905C776.04 415.806 775.626 417.008 775.626 418.51C775.626 420.087 776.04 421.363 776.866 422.34C777.692 423.278 778.818 423.748 780.245 423.748ZM800.52 427.239C798.868 427.239 797.366 426.864 796.014 426.113C794.7 425.362 793.668 424.329 792.917 423.015C792.166 421.664 791.79 420.162 791.79 418.51C791.79 416.895 792.166 415.45 792.917 414.173C793.668 412.897 794.7 411.902 796.014 411.188C797.366 410.437 798.868 410.062 800.52 410.062C802.172 410.062 803.655 410.437 804.969 411.188C806.283 411.902 807.316 412.897 808.067 414.173C808.855 415.45 809.25 416.895 809.25 418.51C809.25 420.162 808.855 421.664 808.067 423.015C807.316 424.329 806.283 425.362 804.969 426.113C803.655 426.864 802.172 427.239 800.52 427.239ZM800.52 423.748C801.984 423.748 803.167 423.278 804.068 422.34C804.969 421.363 805.42 420.087 805.42 418.51C805.42 417.008 804.969 415.806 804.068 414.905C803.167 414.004 801.984 413.554 800.52 413.554C799.018 413.554 797.817 414.004 796.915 414.905C796.052 415.806 795.62 417.008 795.62 418.51C795.62 420.087 796.052 421.363 796.915 422.34C797.817 423.278 799.018 423.748 800.52 423.748ZM818.971 427.239C817.507 427.239 816.305 426.789 815.366 425.888C814.428 424.987 813.958 423.635 813.958 421.833V414.68C813.958 414.305 813.771 414.117 813.395 414.117H812.381C811.893 414.117 811.48 413.967 811.142 413.666C810.804 413.328 810.636 412.915 810.636 412.427C810.636 411.902 810.804 411.47 811.142 411.132C811.48 410.794 811.893 410.625 812.381 410.625H813.395C813.771 410.625 813.958 410.437 813.958 410.062V405.331C813.958 404.805 814.127 404.392 814.465 404.092C814.841 403.754 815.291 403.585 815.817 403.585C816.38 403.585 816.831 403.754 817.169 404.092C817.544 404.392 817.732 404.805 817.732 405.331V410.062C817.732 410.437 817.92 410.625 818.295 410.625H821.336C821.787 410.625 822.181 410.794 822.519 411.132C822.857 411.47 823.026 411.902 823.026 412.427C823.026 412.915 822.857 413.328 822.519 413.666C822.219 413.967 821.806 414.117 821.28 414.117H818.295C817.92 414.117 817.732 414.305 817.732 414.68V421.326C817.732 422.903 818.37 423.691 819.647 423.691C820.022 423.691 820.416 423.635 820.829 423.522C821.242 423.41 821.524 423.353 821.674 423.353C822.2 423.353 822.594 423.522 822.857 423.86C823.157 424.198 823.308 424.592 823.308 425.043C823.308 425.381 823.214 425.719 823.026 426.057C822.838 426.357 822.538 426.582 822.125 426.732C821.712 426.883 821.186 426.995 820.548 427.07C819.947 427.183 819.421 427.239 818.971 427.239ZM833.965 427.239C831.149 427.239 828.953 426.432 827.376 424.818C825.799 423.203 825.01 421.025 825.01 418.284C825.01 415.881 825.799 413.91 827.376 412.371C828.99 410.831 831.055 410.062 833.571 410.062C836.012 410.062 837.964 410.775 839.428 412.202C840.893 413.591 841.625 415.318 841.625 417.383C841.625 418.209 841.399 418.829 840.949 419.242C840.536 419.655 839.991 419.861 839.316 419.861H829.516C829.14 419.861 829.009 420.068 829.122 420.481C829.422 421.532 830.023 422.358 830.924 422.959C831.863 423.522 832.914 423.804 834.078 423.804C834.941 423.804 835.767 423.691 836.556 423.466C837.382 423.241 838.095 422.903 838.696 422.452C838.884 422.302 839.128 422.227 839.428 422.227C839.841 422.227 840.217 422.415 840.555 422.79C840.893 423.128 841.062 423.541 841.062 424.029C841.062 424.254 841.024 424.48 840.949 424.705C840.874 424.93 840.705 425.156 840.442 425.381C839.466 426.094 838.414 426.582 837.288 426.845C836.199 427.108 835.092 427.239 833.965 427.239ZM837.232 416.933C837.457 416.933 837.57 416.82 837.57 416.595C837.57 415.731 837.175 414.98 836.387 414.342C835.636 413.704 834.697 413.385 833.571 413.385C832.595 413.385 831.656 413.647 830.755 414.173C829.891 414.699 829.366 415.393 829.178 416.257C829.178 416.257 829.178 416.276 829.178 416.313C829.14 416.463 829.122 416.595 829.122 416.708C829.159 416.82 829.328 416.876 829.629 416.876L837.232 416.933ZM859.138 427.239C858.65 427.239 858.199 427.089 857.786 426.789C857.411 426.488 857.223 426.057 857.223 425.493V418.397C857.223 416.745 856.848 415.525 856.097 414.736C855.383 413.948 854.426 413.554 853.224 413.554C851.685 413.554 850.559 414.06 849.845 415.074C849.169 416.05 848.831 417.139 848.831 418.341V425.493C848.831 426.057 848.625 426.488 848.212 426.789C847.837 427.089 847.405 427.239 846.917 427.239C846.428 427.239 845.978 427.089 845.565 426.789C845.189 426.488 845.002 426.057 845.002 425.493V412.258C845.002 411.62 845.189 411.151 845.565 410.85C845.978 410.512 846.428 410.343 846.917 410.343C847.405 410.343 847.837 410.512 848.212 410.85C848.625 411.151 848.831 411.62 848.831 412.258C849.47 411.62 850.296 411.094 851.31 410.681C852.323 410.268 853.281 410.062 854.182 410.062C856.285 410.062 857.955 410.738 859.194 412.089C860.433 413.441 861.053 415.431 861.053 418.059V425.493C861.053 426.057 860.846 426.488 860.433 426.789C860.02 427.089 859.589 427.239 859.138 427.239ZM871.661 427.239C870.197 427.239 868.995 426.789 868.056 425.888C867.118 424.987 866.648 423.635 866.648 421.833V414.68C866.648 414.305 866.461 414.117 866.085 414.117H865.071C864.583 414.117 864.17 413.967 863.832 413.666C863.495 413.328 863.326 412.915 863.326 412.427C863.326 411.902 863.495 411.47 863.832 411.132C864.17 410.794 864.583 410.625 865.071 410.625H866.085C866.461 410.625 866.648 410.437 866.648 410.062V405.331C866.648 404.805 866.817 404.392 867.155 404.092C867.531 403.754 867.981 403.585 868.507 403.585C869.07 403.585 869.521 403.754 869.859 404.092C870.234 404.392 870.422 404.805 870.422 405.331V410.062C870.422 410.437 870.61 410.625 870.985 410.625H874.026C874.477 410.625 874.871 410.794 875.209 411.132C875.547 411.47 875.716 411.902 875.716 412.427C875.716 412.915 875.547 413.328 875.209 413.666C874.909 413.967 874.496 414.117 873.97 414.117H870.985C870.61 414.117 870.422 414.305 870.422 414.68V421.326C870.422 422.903 871.06 423.691 872.337 423.691C872.712 423.691 873.106 423.635 873.519 423.522C873.932 423.41 874.214 423.353 874.364 423.353C874.89 423.353 875.284 423.522 875.547 423.86C875.847 424.198 875.998 424.592 875.998 425.043C875.998 425.381 875.904 425.719 875.716 426.057C875.528 426.357 875.228 426.582 874.815 426.732C874.402 426.883 873.876 426.995 873.238 427.07C872.637 427.183 872.111 427.239 871.661 427.239ZM880.798 427.239C880.31 427.239 879.859 427.089 879.446 426.789C879.071 426.488 878.883 426.057 878.883 425.493V411.977C878.883 411.338 879.071 410.869 879.446 410.569C879.859 410.231 880.31 410.062 880.798 410.062C881.286 410.062 881.718 410.231 882.093 410.569C882.506 410.869 882.713 411.338 882.713 411.977V425.493C882.713 426.057 882.506 426.488 882.093 426.789C881.718 427.089 881.286 427.239 880.798 427.239ZM880.854 406.964C880.141 406.964 879.521 406.739 878.996 406.288C878.508 405.8 878.264 405.218 878.264 404.542C878.264 403.904 878.508 403.36 878.996 402.909C879.521 402.421 880.141 402.177 880.854 402.177C881.53 402.177 882.112 402.421 882.6 402.909C883.088 403.36 883.332 403.904 883.332 404.542C883.332 405.218 883.088 405.8 882.6 406.288C882.112 406.739 881.53 406.964 880.854 406.964ZM894.562 427.239C892.948 427.239 891.502 426.864 890.225 426.113C888.949 425.362 887.954 424.329 887.24 423.015C886.527 421.664 886.17 420.162 886.17 418.51C886.17 416.895 886.527 415.45 887.24 414.173C887.954 412.897 888.949 411.902 890.225 411.188C891.502 410.437 892.948 410.062 894.562 410.062C895.613 410.062 896.552 410.249 897.378 410.625C898.204 410.963 898.917 411.413 899.518 411.977C899.593 411.451 899.819 411.057 900.194 410.794C900.569 410.494 900.983 410.343 901.433 410.343C901.921 410.343 902.353 410.512 902.728 410.85C903.141 411.151 903.348 411.62 903.348 412.258V425.493C903.348 426.057 903.141 426.488 902.728 426.789C902.353 427.089 901.921 427.239 901.433 427.239C900.945 427.239 900.494 427.089 900.081 426.789C899.706 426.488 899.518 426.057 899.518 425.493V425.268C898.917 425.869 898.204 426.338 897.378 426.676C896.552 427.052 895.613 427.239 894.562 427.239ZM894.9 423.748C896.327 423.748 897.453 423.278 898.279 422.34C899.105 421.363 899.518 420.087 899.518 418.51C899.518 417.008 899.105 415.806 898.279 414.905C897.453 414.004 896.327 413.554 894.9 413.554C893.436 413.554 892.253 414.004 891.352 414.905C890.451 415.806 890 417.008 890 418.51C890 420.087 890.451 421.363 891.352 422.34C892.253 423.278 893.436 423.748 894.9 423.748ZM909.507 427.239C909.018 427.239 908.568 427.089 908.155 426.789C907.779 426.488 907.592 426.057 907.592 425.493V404.092C907.592 403.454 907.779 402.984 908.155 402.684C908.568 402.346 909.018 402.177 909.507 402.177C909.995 402.177 910.427 402.346 910.802 402.684C911.215 402.984 911.421 403.454 911.421 404.092V425.493C911.421 426.057 911.215 426.488 910.802 426.789C910.427 427.089 909.995 427.239 909.507 427.239Z",
    fill: "#5F4077"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter13_f_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-76.5654 1190.75C-85.4343 1212.79 -86.8761 1211.96 -99.7587 1225.71C-95.2955 1214.81 -97.2011 1204.32 -96.8366 1190.39L-103.24 1198.24C-106.761 1184.87 -111.118 1179.28 -121.113 1171.11L-126.486 1179.46C-135.889 1164.67 -140.391 1156.89 -142.077 1140.57L-145.227 1148.66C-145.227 1148.66 -174.766 1107.45 -170.64 1080.58C-168.039 1063.64 -163.887 1051.71 -151.018 1043.07C-152.588 1033.13 -180.835 1034.08 -171.584 1027.11C-162.332 1020.14 -148.338 1041.39 -148.338 1041.39C-133.254 1032.6 -119.339 1035.42 -101.926 1042.98C-72.7059 1055.68 -58.6636 1109.35 -54.868 1119.38C-46.1548 1142.4 -65.5862 1195.25 -65.5862 1195.25C-65.5862 1195.25 -67.6966 1168.72 -76.5654 1190.75Z",
    fill: "url(#paint37_linear_3004_95)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.659 925.907C203.246 895.383 205.294 896.847 231.388 879.086C220.091 894.172 219.341 909.791 213.618 930.02L226.96 919.716C227.788 939.814 232.846 948.718 246.155 962.39L258 951.18C267.907 974.382 272.398 986.497 269.144 1010.56L277.262 999.34C277.262 999.34 310.323 1064.57 293.696 1102.99C283.216 1127.2 272.05 1143.84 247.859 1154.15C246.765 1168.91 293.23 1172.51 275.561 1181.03C257.892 1189.55 242.867 1156.12 242.867 1156.12C215.007 1166.26 193.328 1159.69 167.685 1145.6C124.654 1121.94 121.479 1041.3 118.973 1026.02C113.22 990.952 164.389 917.422 164.389 917.422C164.389 917.422 158.072 956.431 180.659 925.907Z",
    fill: "url(#paint38_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-95.758 1030.16C-78.8595 1022.56 -97.3719 983.59 -97.3719 983.59C-97.3719 983.59 -65.5835 1025.7 -51.9952 1009.98C-43.9771 1000.7 -49.063 979.108 -49.063 979.108C-30.9213 1015.59 -9.52827 1073.13 -2.60832 1072.53C4.31163 1071.92 5.69203 1041.49 5.69203 1041.49L7.29964 997.111C7.29964 997.111 13.5074 1004.39 18.347 1005.11C23.1865 1005.82 55.3952 970.799 55.3952 970.799C55.3952 970.799 53.918 1011.35 67.4848 1007.68C81.0515 1004.02 85.2288 997.977 85.2288 997.977C88.0799 997.983 72.3565 1052.08 72.3565 1052.08C72.3565 1052.08 49.4254 1090 42.9448 1099.95C50.9941 1093.6 84.8794 1094.51 81.0433 1100.12C81.0433 1100.12 61.2723 1107.97 61.7428 1110.67C62.2133 1113.38 92.7783 1118.61 92.7783 1118.61C92.7783 1118.61 66.7595 1137.59 67.6897 1142.62C68.6199 1147.64 83.8082 1153.97 83.8082 1153.97C83.8082 1153.97 39.1077 1153.49 13.0397 1166.93C13.0397 1166.93 40.8427 1214.43 43.2811 1222.21C45.7194 1229.98 46.1514 1234.48 46.1514 1234.48C46.1514 1234.48 45.2933 1254.72 37.1743 1255.4C29.0552 1256.09 36.0267 1233.96 32.7513 1221.44C27.1112 1199.89 6.36066 1170.98 6.36066 1170.98C-16.9389 1187.48 -36.8851 1226.12 -36.8851 1226.12C-36.8851 1226.12 -38.0106 1205.58 -42.9841 1205.73C-47.9576 1205.88 -70.8816 1225.35 -70.8816 1225.35C-70.8816 1225.35 -68.2171 1196.21 -70.5772 1193.74C-72.9372 1191.28 -88.0352 1199.54 -88.0352 1199.54C-88.0352 1199.54 -72.727 1167.63 -76.278 1167.79C-79.8289 1167.96 -113.842 1170.76 -135.138 1162.23C-149.358 1156.53 -167.965 1141.04 -167.965 1141.04C-167.965 1141.04 -151.847 1137.99 -147.887 1130.06C-141.363 1116.98 -174.976 1104.94 -174.976 1104.94C-174.976 1104.94 -138.26 1111.97 -131.449 1096.15C-128.445 1089.17 -130.881 1076.86 -130.881 1076.86C-110.149 1097.67 -95.4336 1106.04 -64.0681 1115.44C-82.5165 1077.83 -95.6875 1058.33 -123.373 1025.89C-123.373 1025.89 -105.794 1034.67 -95.758 1030.16Z",
    fill: "url(#paint39_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6733 1182.95C52.6672 1183.75 40.4394 1206.3 55.4048 1213.06C71.5947 1220.38 75.8558 1189.45 82.3356 1189.69C85.8702 1189.82 91.1791 1203.32 102.048 1200.16C114.09 1196.66 100.358 1175.55 110.978 1168.88C117.425 1164.84 126.098 1194.27 141.93 1195.09C162.631 1196.17 120.964 1127.88 140.62 1123.81C154.084 1121.02 163.664 1151.29 182.84 1148.57C205.13 1145.42 135.943 1067.13 160.99 1067.25C172.161 1067.3 181.515 1083.2 188.148 1077.58C195.651 1071.22 191.232 1055.59 183.984 1045.01C179.391 1038.31 163.588 1024.62 162.932 1016.78C161.316 997.462 151.853 980.95 134.338 974.341C134.297 974.325 134.256 974.31 134.214 974.294C132.62 972.951 147.536 943.086 138.001 940.473C131.813 938.776 132.76 972.899 127.457 972.403C108.213 969.079 89.9415 984.803 82.0283 991.84C70.9119 1001.73 42.7359 1000.28 46.1399 1014.76C47.7593 1021.64 58.1153 1019.11 59.148 1026.11C60.9734 1038.48 10.8589 1048.62 19.7784 1075.31C27.851 1099.46 45.5049 1084.58 46.708 1088.26C50.3877 1099.52 10.2685 1107.49 16.4962 1124.32C24.9682 1147.22 41.2872 1129.8 45.7648 1142.64C49.3236 1152.84 14.0383 1159.24 25.6232 1180.27C31.4996 1190.93 44.6795 1182.15 48.6733 1182.95Z",
    fill: "url(#paint40_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.005 1123.77C313.103 1143.02 311.903 1141.87 296.093 1152.13C303.044 1142.62 303.714 1131.98 307.415 1118.54L299.313 1124.63C299.107 1110.8 296.219 1104.33 288.48 1094L281.259 1100.81C275.683 1084.19 273.179 1075.57 275.463 1059.32L270.463 1066.42C270.463 1066.42 251.685 1019.32 262.146 994.22C268.74 978.399 275.634 967.822 290.203 962.521C291.066 952.496 263.417 946.633 274.072 942.088C284.728 937.544 293.207 961.536 293.207 961.536C309.961 956.626 322.791 962.705 337.878 974.232C363.193 993.575 363.933 1049.05 365.209 1059.69C368.138 1084.13 336.583 1130.77 336.583 1130.77C336.583 1130.77 340.906 1104.51 327.005 1123.77Z",
    fill: "url(#paint41_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1100.39 1170.08C1086.48 1189.34 1085.28 1188.19 1069.47 1198.45C1076.43 1188.94 1077.1 1178.3 1080.8 1164.86L1072.69 1170.94C1072.49 1157.12 1069.6 1150.65 1061.86 1140.31L1054.64 1147.13C1049.06 1130.51 1046.56 1121.89 1048.84 1105.64L1043.84 1112.73C1043.84 1112.73 1025.07 1065.64 1035.53 1040.54C1042.12 1024.72 1049.02 1014.14 1063.58 1008.84C1064.45 998.814 1036.8 992.951 1047.45 988.406C1058.11 983.862 1066.59 1007.85 1066.59 1007.85C1083.34 1002.94 1096.17 1009.02 1111.26 1020.55C1136.57 1039.89 1137.31 1095.37 1138.59 1106.01C1141.52 1130.45 1109.96 1177.08 1109.96 1177.08C1109.96 1177.08 1114.29 1150.82 1100.39 1170.08Z",
    fill: "url(#paint42_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.31 928.453C669.568 904.247 671.204 906.16 700.8 895.186C686.21 907.118 681.731 922.099 671.317 940.362L686.743 933.564C682.72 953.272 685.491 963.13 695.127 979.599L709.317 971.562C713.362 996.465 714.812 1009.3 705.873 1031.88L716.449 1022.94C716.449 1022.94 732.873 1094.2 707.507 1127.5C691.517 1148.49 676.684 1161.95 650.723 1166.16C646.118 1180.22 690.356 1194.88 671.159 1198.9C651.961 1202.93 645.404 1166.87 645.404 1166.87C615.925 1170.02 596.458 1158.44 574.95 1138.6C538.86 1105.3 555.148 1026.25 556.385 1010.82C559.223 975.396 626.554 916.308 626.554 916.308C626.554 916.308 611.053 952.658 640.31 928.453Z",
    fill: "url(#paint43_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.945 963.265C365.173 959.949 356.564 917.67 356.564 917.67C356.564 917.67 377.307 966.184 394.275 954.181C404.287 947.099 404.535 924.922 404.535 924.922C413.383 964.693 420.331 1025.68 427.193 1026.76C434.055 1027.84 442.704 998.628 442.704 998.628L454.924 955.935C454.924 955.935 459.201 964.494 463.728 966.349C468.254 968.204 507.931 941.945 507.931 941.945C507.931 941.945 496.758 980.954 510.808 980.654C524.858 980.354 530.364 975.493 530.364 975.493C533.13 976.183 504.875 1024.92 504.875 1024.92C504.875 1024.92 473.506 1056.23 464.826 1064.32C474.165 1060.09 506.838 1069.12 501.769 1073.64C501.769 1073.64 480.691 1076.51 480.498 1079.25C480.304 1081.99 508.719 1094.41 508.719 1094.41C508.719 1094.41 478.903 1106.58 478.599 1111.69C478.294 1116.79 491.519 1126.57 491.519 1126.57C491.519 1126.57 448.241 1115.38 419.709 1122.16C419.709 1122.16 435.29 1174.95 435.789 1183.08C436.288 1191.22 435.628 1195.68 435.628 1195.68C435.628 1195.68 429.933 1215.13 421.887 1213.84C413.841 1212.56 425.923 1192.75 425.751 1179.81C425.453 1157.53 412.251 1124.49 412.251 1124.49C385.671 1134.91 357.028 1167.63 357.028 1167.63C357.028 1167.63 360.869 1147.42 356.005 1146.37C351.141 1145.33 324.214 1158.71 324.214 1158.71C324.214 1158.71 333.799 1131.07 332.1 1128.1C330.401 1125.14 313.761 1129.54 313.761 1129.54C313.761 1129.54 336.284 1102.24 332.798 1101.55C329.312 1100.85 295.62 1095.41 276.997 1082.01C264.562 1073.06 250.22 1053.56 250.22 1053.56C250.22 1053.56 266.598 1054.47 272.349 1047.72C281.823 1036.59 252.086 1016.83 252.086 1016.83C252.086 1016.83 286.038 1032.47 296.449 1018.75C301.042 1012.7 301.635 1000.16 301.635 1000.16C316.761 1025.34 329.034 1037.01 357.225 1053.66C348.35 1012.72 340.248 990.625 321.164 952.488C321.164 952.488 336.119 965.233 346.945 963.265Z",
    fill: "url(#paint44_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.451 1146.27C454.136 1148.01 436.85 1166.96 449.753 1177.12C463.712 1188.11 475.276 1159.11 481.51 1160.9C484.91 1161.87 486.821 1176.25 498.13 1175.8C510.661 1175.29 502.401 1151.5 514.311 1147.58C521.542 1145.2 522.892 1175.85 538.061 1180.46C557.897 1186.48 533.852 1110.18 553.91 1110.95C567.651 1111.47 569.682 1143.15 588.948 1145.12C611.344 1147.41 562.985 1054.8 587.27 1060.93C598.101 1063.67 603.363 1081.34 611.152 1077.48C619.962 1073.11 619.427 1056.88 614.931 1044.87C612.083 1037.26 600.029 1020.18 601.276 1012.41C604.347 993.267 599.128 974.966 583.712 964.344C583.676 964.319 583.64 964.294 583.604 964.269C582.378 962.582 604.031 937.174 595.403 932.347C589.803 929.214 582.527 962.565 577.498 960.81C559.616 952.961 538.103 963.836 528.731 968.767C515.566 975.693 488.563 967.518 488.389 982.391C488.307 989.468 498.969 989.491 498.29 996.535C497.09 1008.99 446.007 1006.8 448.256 1034.84C450.291 1060.23 471.003 1050.02 471.286 1053.88C472.153 1065.7 431.295 1063.8 433.298 1081.63C436.022 1105.89 456.047 1092.9 457.311 1106.44C458.316 1117.2 422.524 1114.94 428.72 1138.13C431.863 1149.89 446.766 1144.54 450.451 1146.27Z",
    fill: "url(#paint45_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1404 944.93C1433.26 920.724 1434.89 922.637 1464.49 911.663C1449.9 923.595 1445.42 938.576 1435 956.839L1450.43 950.041C1446.41 969.749 1449.18 979.607 1458.81 996.076L1473 988.039C1477.05 1012.94 1478.5 1025.78 1469.56 1048.36L1480.14 1039.42C1480.14 1039.42 1496.56 1110.68 1471.19 1143.98C1455.21 1164.97 1440.37 1178.43 1414.41 1182.64C1409.81 1196.69 1454.04 1211.36 1434.85 1215.38C1415.65 1219.4 1409.09 1183.35 1409.09 1183.35C1379.61 1186.5 1360.15 1174.92 1338.64 1155.07C1302.55 1121.78 1318.84 1042.73 1320.07 1027.3C1322.91 991.873 1390.24 932.786 1390.24 932.786C1390.24 932.786 1374.74 969.135 1404 944.93Z",
    fill: "url(#paint46_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1110.63 979.742C1128.86 976.426 1120.25 934.147 1120.25 934.147C1120.25 934.147 1140.99 982.661 1157.96 970.659C1167.98 963.576 1168.22 941.399 1168.22 941.399C1177.07 981.17 1184.02 1042.16 1190.88 1043.24C1197.74 1044.32 1206.39 1015.11 1206.39 1015.11L1218.61 972.412C1218.61 972.412 1222.89 980.971 1227.42 982.826C1231.94 984.681 1271.62 958.422 1271.62 958.422C1271.62 958.422 1260.45 997.431 1274.5 997.131C1288.55 996.831 1294.05 991.97 1294.05 991.97C1296.82 992.66 1268.56 1041.39 1268.56 1041.39C1268.56 1041.39 1237.19 1072.7 1228.51 1080.8C1237.85 1076.57 1270.53 1085.6 1265.46 1090.11C1265.46 1090.11 1244.38 1092.99 1244.19 1095.73C1243.99 1098.47 1272.41 1110.88 1272.41 1110.88C1272.41 1110.88 1242.59 1123.06 1242.29 1128.16C1241.98 1133.27 1255.21 1143.05 1255.21 1143.05C1255.21 1143.05 1211.93 1131.85 1183.4 1138.64C1183.4 1138.64 1198.98 1191.43 1199.48 1199.56C1199.98 1207.7 1199.32 1212.16 1199.32 1212.16C1199.32 1212.16 1193.62 1231.6 1185.58 1230.32C1177.53 1229.03 1189.61 1209.23 1189.44 1196.29C1189.14 1174.01 1175.94 1140.97 1175.94 1140.97C1149.36 1151.39 1120.72 1184.11 1120.72 1184.11C1120.72 1184.11 1124.56 1163.9 1119.69 1162.85C1114.83 1161.8 1087.9 1175.19 1087.9 1175.19C1087.9 1175.19 1097.49 1147.54 1095.79 1144.58C1094.09 1141.62 1077.45 1146.01 1077.45 1146.01C1077.45 1146.01 1099.97 1118.72 1096.49 1118.03C1093 1117.33 1059.31 1111.89 1040.68 1098.49C1028.25 1089.54 1013.91 1070.03 1013.91 1070.03C1013.91 1070.03 1030.29 1070.95 1036.04 1064.19C1045.51 1053.06 1015.77 1033.3 1015.77 1033.3C1015.77 1033.3 1049.73 1048.95 1060.14 1035.23C1064.73 1029.17 1065.32 1016.64 1065.32 1016.64C1080.45 1041.82 1092.72 1053.48 1120.91 1070.14C1112.04 1029.2 1103.94 1007.1 1084.85 968.965C1084.85 968.965 1099.81 981.711 1110.63 979.742Z",
    fill: "url(#paint47_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704.633 959.742C722.861 956.426 714.252 914.147 714.252 914.147C714.252 914.147 734.995 962.661 751.963 950.659C761.975 943.576 762.223 921.399 762.223 921.399C771.071 961.17 778.019 1022.16 784.881 1023.24C791.743 1024.32 800.392 995.105 800.392 995.105L812.612 952.412C812.612 952.412 816.889 960.971 821.415 962.826C825.942 964.681 865.619 938.422 865.619 938.422C865.619 938.422 854.446 977.431 868.496 977.131C882.546 976.831 888.052 971.97 888.052 971.97C890.818 972.66 862.562 1021.39 862.562 1021.39C862.562 1021.39 831.193 1052.7 822.514 1060.8C831.853 1056.57 864.526 1065.6 859.457 1070.11C859.457 1070.11 838.379 1072.99 838.185 1075.73C837.992 1078.47 866.407 1090.88 866.407 1090.88C866.407 1090.88 836.591 1103.06 836.287 1108.16C835.982 1113.27 849.207 1123.05 849.207 1123.05C849.207 1123.05 805.929 1111.85 777.397 1118.64C777.397 1118.64 792.977 1171.43 793.476 1179.56C793.975 1187.7 793.316 1192.16 793.316 1192.16C793.316 1192.16 787.621 1211.6 779.575 1210.32C771.529 1209.03 783.611 1189.23 783.438 1176.29C783.141 1154.01 769.939 1120.97 769.939 1120.97C743.359 1131.39 714.716 1164.11 714.716 1164.11C714.716 1164.11 718.557 1143.9 713.693 1142.85C708.829 1141.8 681.902 1155.19 681.902 1155.19C681.902 1155.19 691.487 1127.54 689.788 1124.58C688.089 1121.62 671.449 1126.01 671.449 1126.01C671.449 1126.01 693.972 1098.72 690.486 1098.03C686.999 1097.33 653.308 1091.89 634.685 1078.49C622.249 1069.54 607.908 1050.03 607.908 1050.03C607.908 1050.03 624.286 1050.95 630.037 1044.19C639.511 1033.06 609.773 1013.3 609.773 1013.3C609.773 1013.3 643.725 1028.95 654.137 1015.23C658.73 1009.17 659.322 996.637 659.322 996.637C674.449 1021.82 686.722 1033.48 714.912 1050.14C706.038 1009.2 697.936 987.102 678.852 948.965C678.852 948.965 693.807 961.711 704.633 959.742Z",
    fill: "url(#paint48_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1214.14 1162.75C1217.82 1164.49 1200.54 1183.44 1213.44 1193.6C1227.4 1204.59 1238.96 1175.59 1245.2 1177.38C1248.6 1178.35 1250.51 1192.73 1261.82 1192.27C1274.35 1191.77 1266.09 1167.98 1278 1164.06C1285.23 1161.68 1286.58 1192.33 1301.75 1196.94C1321.59 1202.96 1297.54 1126.66 1317.6 1127.43C1331.34 1127.95 1333.37 1159.63 1352.64 1161.6C1375.03 1163.89 1326.67 1071.28 1350.96 1077.41C1361.79 1080.14 1367.05 1097.82 1374.84 1093.96C1383.65 1089.59 1383.11 1073.36 1378.62 1061.35C1375.77 1053.74 1363.72 1036.65 1364.96 1028.89C1368.04 1009.74 1362.82 991.443 1347.4 980.821C1347.36 980.796 1347.33 980.771 1347.29 980.746C1346.07 979.059 1367.72 953.651 1359.09 948.824C1353.49 945.691 1346.21 979.042 1341.19 977.287C1323.3 969.438 1301.79 980.313 1292.42 985.244C1279.25 992.17 1252.25 983.995 1252.08 998.869C1251.99 1005.94 1262.66 1005.97 1261.98 1013.01C1260.78 1025.46 1209.69 1023.27 1211.94 1051.32C1213.98 1076.7 1234.69 1066.5 1234.97 1070.36C1235.84 1082.18 1194.98 1080.27 1196.99 1098.11C1199.71 1122.37 1219.73 1109.38 1221 1122.92C1222 1133.67 1186.21 1131.42 1192.41 1154.61C1195.55 1166.37 1210.45 1161.02 1214.14 1162.75Z",
    fill: "url(#paint49_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M988.429 937.331C1017.69 913.125 1019.32 915.038 1048.92 904.064C1034.33 915.995 1029.85 930.977 1019.44 949.24L1034.86 942.442C1030.84 962.15 1033.61 972.008 1043.25 988.477L1057.44 980.44C1061.48 1005.34 1062.93 1018.18 1053.99 1040.76L1064.57 1031.82C1064.57 1031.82 1080.99 1103.08 1055.63 1136.38C1039.64 1157.37 1024.8 1170.83 998.842 1175.04C994.237 1189.09 1038.48 1203.76 1019.28 1207.78C1000.08 1211.81 993.523 1175.75 993.523 1175.75C964.044 1178.9 944.577 1167.32 923.069 1147.48C886.979 1114.18 903.267 1035.13 904.503 1019.7C907.342 984.274 974.673 925.186 974.673 925.186C974.673 925.186 959.172 961.536 988.429 937.331Z",
    fill: "url(#paint50_linear_3004_95)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_df_3004_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M798.57 1155.15C802.254 1156.89 784.968 1175.84 797.872 1186C811.831 1196.99 823.395 1167.99 829.628 1169.78C833.028 1170.75 834.939 1185.13 846.249 1184.67C858.779 1184.17 850.52 1160.38 862.43 1156.46C869.661 1154.08 871.011 1184.73 886.18 1189.34C906.016 1195.36 881.971 1119.06 902.029 1119.83C915.77 1120.35 917.801 1152.03 937.066 1154C959.463 1156.29 911.104 1063.68 935.389 1069.81C946.22 1072.54 951.482 1090.22 959.271 1086.36C968.081 1081.99 967.546 1065.76 963.05 1053.75C960.201 1046.14 948.148 1029.06 949.395 1021.29C952.466 1002.15 947.246 983.844 931.831 973.221C931.795 973.197 931.759 973.172 931.722 973.147C930.497 971.459 952.15 946.051 943.522 941.224C937.922 938.092 930.646 971.443 925.617 969.688C907.734 961.839 886.221 972.714 876.85 977.644C863.684 984.571 836.682 976.396 836.508 991.269C836.425 998.346 847.088 998.369 846.409 1005.41C845.209 1017.86 794.125 1015.67 796.374 1043.72C798.41 1069.1 819.121 1058.9 819.405 1062.76C820.272 1074.58 779.414 1072.67 781.416 1090.51C784.141 1114.77 804.166 1101.78 805.43 1115.32C806.434 1126.07 770.643 1123.82 776.839 1147.01C779.982 1158.77 794.885 1153.42 798.57 1155.15Z",
    fill: "url(#paint51_linear_3004_95)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3004_95",
    x: 59.4296,
    y: 144.995,
    width: 379.535,
    height: 423.718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.224,
    dy: 4.224
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.112
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_3004_95",
    x: -82.102,
    y: 53.1225,
    width: 169.215,
    height: 227.915,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.632,
    dy: -5.632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.04
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.52,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_df_3004_95",
    x: 819.201,
    y: -82.9897,
    width: 192.707,
    height: 217.005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.632,
    dy: -5.632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.04
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.52,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_df_3004_95",
    x: 446.863,
    y: 126.861,
    width: 206.664,
    height: 235.521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.632,
    dy: 5.632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.04
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.408,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_df_3004_95",
    x: 1259.59,
    y: 582.825,
    width: 207.942,
    height: 232.807,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.632,
    dy: 5.632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.04
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.408,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_df_3004_95",
    x: 294.726,
    y: 486.123,
    width: 202.405,
    height: 183.806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.632,
    dy: 5.632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.04
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.408,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_df_3004_95",
    x: 941.751,
    y: 289.727,
    width: 308.54,
    height: 209.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.632,
    dy: 5.632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.04
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2816,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_df_3004_95",
    x: 1210.47,
    y: 61.1562,
    width: 355.612,
    height: 387.117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.632,
    dy: 11.264
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.04
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.632,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_df_3004_95",
    x: -43.3741,
    y: 726.096,
    width: 373.88,
    height: 359.672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.632,
    dy: 11.264
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.04
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.632,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_df_3004_95",
    x: 705.086,
    y: 476.96,
    width: 219.547,
    height: 299.825,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.632,
    dy: -5.632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.04
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.52,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_3004_95",
    x: 366.889,
    y: 189.257,
    width: 634.202,
    height: 253.299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.224,
    dy: 4.224
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.112
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.890196 0 0 0 0 0.768627 0 0 0 0 0.984314 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_3004_95",
    x: 983.746,
    y: 212.847,
    width: 266.775,
    height: 193.248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.224,
    dy: 4.224
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.112
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.890196 0 0 0 0 0.768627 0 0 0 0 0.984314 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_3004_95",
    x: 557.528,
    y: 401.473,
    width: 358.822,
    height: 38.2976,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.112,
    dy: 2.112
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.408
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.890196 0 0 0 0 0.768627 0 0 0 0 0.984314 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_3004_95",
    x: -178.976,
    y: 875.086,
    width: 1668.34,
    height: 384.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_df_3004_95",
    x: 110.122,
    y: 870.686,
    width: 207.85,
    height: 331.335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_df_3004_95",
    x: -186.176,
    y: 959.599,
    width: 298.555,
    height: 321.019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 11.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_df_3004_95",
    x: 7.43816,
    y: 932.011,
    width: 204.203,
    height: 301.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.184314 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_df_3004_95",
    x: 250.576,
    y: 921.915,
    width: 134.425,
    height: 238.618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: -5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_df_3004_95",
    x: 1023.96,
    y: 968.234,
    width: 134.425,
    height: 238.618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: -5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_df_3004_95",
    x: 543.257,
    y: 886.786,
    width: 198.022,
    height: 332.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_df_3004_95",
    x: 239.02,
    y: 906.47,
    width: 311.135,
    height: 332.633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 11.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_df_3004_95",
    x: 419.599,
    y: 923.739,
    width: 218.107,
    height: 276.658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.184314 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_df_3004_95",
    x: 1306.94,
    y: 903.263,
    width: 198.022,
    height: 332.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_df_3004_95",
    x: 1002.71,
    y: 922.947,
    width: 311.135,
    height: 332.633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 11.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_df_3004_95",
    x: 596.708,
    y: 902.947,
    width: 311.135,
    height: 332.633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 11.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_df_3004_95",
    x: 1183.29,
    y: 940.216,
    width: 218.108,
    height: 276.658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.184314 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_df_3004_95",
    x: 891.376,
    y: 895.664,
    width: 198.022,
    height: 332.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.0745098 0 0 0 0 0.172549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_df_3004_95",
    x: 767.718,
    y: 932.617,
    width: 218.107,
    height: 276.658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.6,
    dy: 5.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.364706 0 0 0 0 0.184314 0 0 0 0 0.501961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3004_95",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect2_foregroundBlur_3004_95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3004_95",
    x1: -310.865,
    y1: 1406.83,
    x2: 1692.03,
    y2: 1218.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331731,
    stopColor: "#E3C4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3004_95",
    x1: 721.062,
    y1: 1043,
    x2: 721.063,
    y2: 0.0000219879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F4077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3004_95",
    x1: 235.394,
    y1: 197.022,
    x2: 233.975,
    y2: 278.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3004_95",
    x1: 169.195,
    y1: 347.533,
    x2: 167.936,
    y2: 419.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3004_95",
    x1: 297.041,
    y1: 350.005,
    x2: 295.782,
    y2: 422.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3004_95",
    x1: 130.628,
    y1: 292.212,
    x2: 129.162,
    y2: 376.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3004_95",
    x1: 336.776,
    y1: 295.81,
    x2: 335.309,
    y2: 379.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3004_95",
    x1: 169.269,
    y1: 216.331,
    x2: 167.532,
    y2: 315.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3004_95",
    x1: 299.072,
    y1: 218.596,
    x2: 297.336,
    y2: 318.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3004_95",
    x1: 195.547,
    y1: 170.052,
    x2: 194.619,
    y2: 223.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3004_95",
    x1: 275.825,
    y1: 171.487,
    x2: 274.897,
    y2: 224.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3004_95",
    x1: 236.934,
    y1: 144.327,
    x2: 236.102,
    y2: 191.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3004_95",
    x1: 233.5,
    y1: 291.359,
    x2: 232.055,
    y2: 374.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3004_95",
    x1: 230.784,
    y1: 411.542,
    x2: 228.895,
    y2: 519.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3004_95",
    x1: 230.784,
    y1: 411.542,
    x2: 228.895,
    y2: 519.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3004_95",
    x1: 235.394,
    y1: 197.022,
    x2: 233.975,
    y2: 278.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3004_95",
    x1: 169.195,
    y1: 347.533,
    x2: 167.936,
    y2: 419.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3004_95",
    x1: 297.041,
    y1: 350.005,
    x2: 295.782,
    y2: 422.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3004_95",
    x1: 130.628,
    y1: 292.212,
    x2: 129.162,
    y2: 376.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3004_95",
    x1: 336.776,
    y1: 295.81,
    x2: 335.309,
    y2: 379.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3004_95",
    x1: 169.269,
    y1: 216.331,
    x2: 167.532,
    y2: 315.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3004_95",
    x1: 299.072,
    y1: 218.596,
    x2: 297.336,
    y2: 318.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3004_95",
    x1: 195.547,
    y1: 170.052,
    x2: 194.619,
    y2: 223.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3004_95",
    x1: 275.825,
    y1: 171.487,
    x2: 274.897,
    y2: 224.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3004_95",
    x1: 236.934,
    y1: 144.327,
    x2: 236.102,
    y2: 191.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3004_95",
    x1: 233.5,
    y1: 291.359,
    x2: 232.055,
    y2: 374.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3004_95",
    x1: 230.784,
    y1: 411.542,
    x2: 228.895,
    y2: 519.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3004_95",
    x1: 230.784,
    y1: 411.542,
    x2: 228.895,
    y2: 519.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3004_95",
    x1: -58.7896,
    y1: 65.9735,
    x2: 64.4069,
    y2: 242.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177885,
    stopColor: "#5F4077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586538,
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3004_95",
    x1: 972.81,
    y1: -55.582,
    x2: 874.807,
    y2: 135.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177885,
    stopColor: "#5F4077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586538,
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3004_95",
    x1: 625.169,
    y1: 134.67,
    x2: 489.89,
    y2: 338.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3004_95",
    x1: 1272.76,
    y1: 796.577,
    x2: 1415.12,
    y2: 597.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3004_95",
    x1: 475.846,
    y1: 498.491,
    x2: 319.516,
    y2: 632.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3004_95",
    x1: 1200.2,
    y1: 332.037,
    x2: 942.9,
    y2: 439.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3004_95",
    x1: 1304.66,
    y1: 99.8121,
    x2: 1520.46,
    y2: 409.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A35C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3004_95",
    x1: 210.884,
    y1: 742.065,
    x2: 24.8094,
    y2: 1070.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A35C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3004_95",
    x1: 884.69,
    y1: 777.639,
    x2: 717.797,
    y2: 537.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177885,
    stopColor: "#5F4077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586538,
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3004_95",
    x1: -159.49,
    y1: 1020.4,
    x2: -59.2813,
    y2: 1203.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3004_95",
    x1: 157.158,
    y1: 904.185,
    x2: 253.349,
    y2: 1188.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3004_95",
    x1: -90.3959,
    y1: 979.774,
    x2: 55.2456,
    y2: 1245.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A35C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3004_95",
    x1: 136.164,
    y1: 940.1,
    x2: 80.4553,
    y2: 1218.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3004_95",
    x1: 287.423,
    y1: 938.482,
    x2: 340.704,
    y2: 1140.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3004_95",
    x1: 1060.8,
    y1: 984.801,
    x2: 1114.09,
    y2: 1186.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3004_95",
    x1: 622.715,
    y1: 901.723,
    x2: 647.764,
    y2: 1200.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3004_95",
    x1: 364.252,
    y1: 915.641,
    x2: 441.69,
    y2: 1209.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A35C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3004_95",
    x1: 593.709,
    y1: 931.544,
    x2: 472.78,
    y2: 1188.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3004_95",
    x1: 1386.4,
    y1: 918.2,
    x2: 1411.45,
    y2: 1217.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3004_95",
    x1: 1127.94,
    y1: 932.118,
    x2: 1205.38,
    y2: 1225.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A35C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3004_95",
    x1: 721.94,
    y1: 912.118,
    x2: 799.378,
    y2: 1205.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A35C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3004_95",
    x1: 1357.4,
    y1: 948.021,
    x2: 1236.47,
    y2: 1204.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3004_95",
    x1: 970.834,
    y1: 910.6,
    x2: 995.883,
    y2: 1209.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3004_95",
    x1: 941.827,
    y1: 940.422,
    x2: 820.898,
    y2: 1197.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageHeader);
export default __webpack_public_path__ + "static/media/homepage-header.d76735ec2a4faf16770a431d7c67e45c.svg";
export { ForwardRef as ReactComponent };